import country from './country';

export default {
  country,
  static: {
    collicareConfirmedShippingReminderEmpty: 'Required order details are missing. Please go to the order details edit page and enter the contact and opening details for delivery.',
    collicareConfirmedShippingReminder: 'Important! Please double-check the details below to ensure accurate and efficient delivery.',
    sharedWarehouseProduct: 'Note! This product is coming from a shared warehouse. Only fields in the "Online Store" tab is available for updates.',
    tripletexCreditNoteNotice: 'Note! Sync to Tripletex is only supported for fully credited invoices',
    loadingProductLines: 'Loading lines…',
    bundleProductPreview: {
      openProductEdit: 'Open product edit',
      bundleProducts: 'Bundle products',
      title: 'Bundle Product view',
      view: 'View',
    },
    productBundles: {
      filters: {
        title: 'Product Bundles',
        all: 'All',
      },
      create: {
        title: 'Add Product Bundle',
      },
      edit: {
        title: 'Edit Product Bundle',
      },
      index: {
        title: 'Product Bundles Overview',
      },
      formTabs: {
        bundleInformation: 'Bundle Information',
      },
    },
    reminderTable: {
      type: 'Type',
      freeAmount: 'Fee Amount',
      dateCreated: 'Date Created',
      reminder: 'Reminder',
      notes: 'Notes',
      percentage: 'Percentage',
      fixed: 'Fixed',
      newDueDate: 'New Due Date',
    },
    sharedWarehouse: {
      notAllowed:
        'You are not allowed to edit this since this is shared warehouse.',
    },
    bulkProcessOrder: {
      title: 'Bulk processing of orders',
    },
    bulkProcessBill: {
      title: 'Bulk processing of bills',
      payment_date_options: {
        selectDate: 'Select a payment date for all the selected bills',
        dueDate: 'Use the bills due date for the payment date for each bill',
      },
    },
    bulkDestroyProducts: {
      title: 'Selected products to be destroyed',
      name: 'Product',
      productQty: 'Qty',
      batch: 'Batch',
      qtyToDestroy: 'To be Destroyed Qty',
      available: 'Qty',
    },
    clientInfo: {
      billAddressMissing:
        'Bill address is missing. Click to update (button above)',
    },
    clientAddress: {
      edit: {
        title: 'Update customer address',
      },
    },
    producers: {
      add: 'Add Producer',
    },
    referenceSign: {
      invoice: 'INV',
      order: 'ORD',
    },
    alertMissingDetails: {
      customerNoContactEmail: {
        message:
          'This customer has no contact email registered. Please update the customer in order to send the invoice.',
        linkText: 'Edit client',
      },
    },
    accountAlert: {
      greetings: 'Hi',
      msgPart1: 'your account subscription',
      msgPart2Ending:
        "please make sure that the subscription is renewed so you won't to lose features in your account. Please contact.",
      msgPart2Ended:
        'your subscription has expired and features on your account may be reduced. Please contact',
      partial: {
        willEndIn: 'your subscription expires in',
        days: 'days',
        day: 'day',
      },
    },
    unpaidInvoiceAlert: {
      title: 'Overdue invoice',
      body:
        'Your Kundan account will be locked if the invoice is not paid. Please pay the overdue invoice, or contact',
    },
    bridgeHandoff: {
      handedOff:
        'Stock operations for this organization have moved to the Inventory App. This view is now read-only — use the Inventory App to create or edit stock, adjustments, transfers and receiving.',
      decommissioned:
        'Stock operations for this organization have been permanently moved to the Inventory App. This module is retained as a read-only archive.',
      openApp: 'Open Inventory App',
      blockedToast:
        'This action has moved to the Inventory App. Use the Inventory App to complete it.',
    },
    widgets: {
      soldProduct: {
        filters: {
          last3Months: 'Last 3 months',
          last6Months: 'Last 6 months',
          thisYear: 'This year',
        },
      },
    },
    license: {
      licenseNumber: 'License #',
      organizationNumber: 'Organization #',
      licenseType: 'License Type',
      licensePermitType: 'License Permit Type',
      validFrom: 'Valid From',
      validTo: 'Valid To',
      add: 'Add License',
      organizationNumberRequired:
        'Please add the organization number in order to add a license',
      groups: 'Groups',
    },
    releaseNote: {
      toast: {
        message:
          'Kundan has been upgraded, please click this to make it yours :)',
      },
      modal: {
        btnNext: 'NEXT',
        btnPrev: 'BACK',
        learnLink: 'Learn More',
        pageOf: 'of',
        versionRelease: 'Release',
      },
      close: {
        gotIt: 'Got it',
      },
    },
    defaultText: {
      noData: 'No Data',
      client: {
        noDataMsg:
          "It looks like you have no clients yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Client',
      },
      clientGroup: {
        noDataMsg:
          "It looks like you have no client groups yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Client Group',
      },
      product: {
        noDataMsg:
          "It looks like you have no products yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Product',
      },
      productGroup: {
        noDataMsg:
          "It looks like you have no product groups yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Product Group',
      },
      order: {
        noDataMsg:
          "It looks like you have no orders yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Order',
      },
      edi: {
        noDataMsg:
          'It looks like you have no edi orders yet. Vinmonpolet usually orders Tuesdays and Thursdays',
      },
      bill: {
        noDataMsg:
          "It looks like you have no bills yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Bill',
      },
      supplier: {
        noDataMsg:
          "It looks like you have no supplier yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Supplier',
      },
      warehouse: {
        noDataMsg:
          "It looks like you have no warehouse yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Warehouse',
      },
      unitOfMeasure: {
        noDataMsg:
          "It looks like you have no unit of measures yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Unit of Measures',
      },
      stock: {
        noDataMsg:
          "It looks like you have no stocks yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Stocks',
      },
      adjustment: {
        noDataMsg:
          "It looks like you have no adjustment yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Adjustment Stock',
      },
      purchase: {
        noDataMsg:
          "It looks like you have no puchase yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Purchase',
      },
      productTags: {
        noDataMsg:
          "It looks like you have no product tag yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Product Tag',
      },
      PriceFields: {
        noDataMsg:
          "It looks like you have no price field yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Price Field',
      },
      exciseEntry: {
        noDataMsg: 'It looks like you have no Excise entries yet',
      },
      material: {
        noDataMsg:
          "It looks like you have no materials yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Add Material',
      },
      batch: {
        noDataMsg:
          "It looks like you have no batch yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Batch',
      },
      recipe: {
        noDataMsg:
          "It looks like you have no recipe yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Add Recipe',
      },
      equipment: {
        noDataMsg:
          "It looks like you have no equipment yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Add Equipment',
      },
      productPackaging: {
        noDataMsg:
          "It looks like you have no packagings yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Add Packaging',
      },
    },

    bulkProductAdd: {
      emptySelectionError: 'Please add atleast one item!',
      saveError: 'Could not save. Please check the details and try again.',
    },
    module: {
      index: {
        title: 'Modules List',
      },
      info: {
        description: 'Description',
        name: 'Name',
        type: 'Type',
        group: 'Group',
        price: 'Price',
      },
      warning: {
        subscribe: 'Subscribe this module?',
        unsubscribe: 'Unsubscribed  this module?',
      },
      error: {
        vmpError:
          'An error occured while enabling the module, please make sure to follow instructions and try again.',
      },
      subscribe: {
        title: 'Subscribe form',
      },
      vmp: {
        intro:
          'For VMP module to work properly please do the the following steps:',
        step1: '1. Follow the descriptions found here:',
        step2: '2. Add the following email to give Kundan access:',
      },
      unimicro: {
        intro:
          'Please provide your UniMicro credentials below to connect your accounting integration.',
        unimicro_client_id: {
          label: 'Client ID',
          placeholder: 'Enter your UniMicro Client ID',
        },
        unimicro_client_secret: {
          label: 'Client Secret',
          placeholder: 'Enter your UniMicro Client Secret',
        },
        unimicro_access_token: {
          label: 'Access Token',
          placeholder: 'Paste your UniMicro Access Token',
        },
        unimicro_refresh_token: {
          label: 'Refresh Token',
          placeholder: 'Paste your UniMicro Refresh Token',
        },
        unimicro_environment: {
          label: 'Environment',
          placeholder: 'Select your UniMicro Environment',
        },
      },
      fiken: {
        intro:
          'Clicking "Subscribe" will redirect you to Fiken site for account authorization.',
        fiken_company_slug: {
          label: 'Company to be used for the integration',
          placeholder: 'Select Company',
        },
      },
      poweroffice: {
        intro:
        'BETA! Our PowerOffice integration offers 2 types; "Standard" and "Alternative".<br><br>Select "Standard" if you want the traditional sync of accounting data when sending invoices from Kundan. For more details on the "Alternative" approach please contact <a href="mailto:support@kundan.no">customer service</a> for more guidance.',
      },
      ehf: {
        intro:
          'By clicking "Subscribe" you agree to the terms of using EHF Module:',
        terms:
          'I understand and accept the fees of sending EHF invoices are set to NOK 3 per EHF',
      },
      visma: {
        intro:
          'Clicking "Subscribe" will redirect you to Visma eAccounting site for account authorization.',
      },
    },
    exciseEntry: {
      title: 'Excise Entries',
      filters: {
        label: 'Filters',
        all: 'All',
        source: {
          all: 'All',
          order: 'Order',
          creditNote: 'Credit Note',
        },
      },
      index: {
        title: 'Excise Product entries',
      },
      allProduct: 'All Products',
      table: {
        productName: 'Product',
        flag: 'Flag',
        qty: 'Quantity',
        exciseType: 'Excise Type',
        exciseGroup: 'Excise Group',
        excisableType: 'Excisable Type',
        createdAt: 'Date',
        additionalCode: 'Additional Code',
        exciseBasic: 'Excise Basic',
        excisePackaging: 'Excise Packaging',
        exciseAdditionalCode: 'Additional Code',
        volume: 'Volume',
        abv: 'ABV',
        liter: 'Liter',
        receiverName: 'Name',
      },
      export: 'Export',
      update: {
        success: 'Successfully Updated',
      },
    },

    wooProducts: {
      attributes: {
        abv: 'ABV',
        beer_style: 'Beer Style',
        country: 'Country',
        ebu: 'EBU',
        ibu: 'IBU',
        packaging_material: 'Packaging Material',
        packaging_type: 'Packaging Type',
        producer: 'Producer',
        quantity_in_crate: 'Quantity in Crate',
        region: 'Region',
        volum: 'Volum',
        weight: 'Weight',
        free_of_alcohol: 'Free of Alcohol',
        free_or_low_on_gluten: 'Free or Low on Gluten',
        sugar: 'Sugar',
        acid: 'Acid',
        fullness: 'Fullness',
        freshness: 'Freshness',
        tannins: 'Tannins',
        bitterness: 'Bitterness',
        colour: 'Colour',
        odour: 'Odour',
        taste: 'Taste',
        storage_potential: 'Storage Potential',
        ingredients: 'Ingredients',
        organic: 'Organic',
        biodynamic: 'Biodynamic',
        locally_produced: 'Locally Produced',
        environmentally_smart: 'Environmentally Smart',
        kosher: 'Kosher',
        recommended_with: 'Recommended With',
      },
    },

    materials: {
      title: 'Materials',
      filters: {
        title: 'Materials',
        active: 'Active',
        deactivated: 'Deactive',
        all: 'All',
      },
      index: {
        title: 'Materials',
      },
      create: {
        title: 'Add Material',
        success: 'Successfully Created',
      },
      edit: {
        title: 'Edit Material',
        success: 'Material edited successfully',
      },
      formTabs: {
        materialInformation: 'Material Information',
      },
      types: {
        malt: 'Malt',
        hops: 'Hops',
        yeast: 'Yeast',
        sugar: 'Sugar',
        various: 'Various',
        packaging: 'Packaging',
        label: 'Label',
        capsuleOrCork: 'Capsule or cork',
        cratesAndBoxes: 'Crates and boxes',
      },
      unitOfMeasures: {
        gram: 'Gram',
        kilogram: 'Kilogram',
        liter: 'Liter',
        piece: 'Piece',
      },
      recipeTypes: {
        beer: 'Beer',
        wine: 'Wine',
        cider: 'Cider',
        liquor: 'Liquor',
      },
      table: {
        name: 'Name',
        description: 'Description',
        materialType: 'Material',
      },
    },

    batches: {
      title: 'Batch',
      filters: {
        title: 'Batch',
        notStarted: 'Not started',
        upcoming: 'Planned',
        ongoing: 'Ongoing',
        completed: 'Complete',
        all: 'All',
      },
      index: {
        title: 'Batch',
      },
      create: {
        title: 'Add Batch',
        success: 'Successfully Created',
      },
      edit: {
        title: 'Edit Batch',
        success: 'Successfully Updated',
      },
      logs: {
        add: 'Add Batch Log',
      },
      view: {
        title: 'View Batch',
        status: 'Status',
        recipe: 'Recipe Name',
        estimated: 'Estimated',
        startDate: 'Start Date',
        endDate: 'End Date',
        plannedStartingDate: 'Planned Starting Date',
        bestBeforeDate: 'Best Before Date',
        upcomingProcedures: 'Upcoming Procedures',
        ongoingProcedures: 'Ongoing Procedures',
        completedProcedures: 'Completed Procedures',
        createBatchTransfer: 'Create Batch Transfer',
        startBatch: {
          title: 'Start batch',
          confirm:
            'All materials amounts specified in the recipe will be deducted from the material warehouse. Do you wish to continue?',
          success: 'Batch started',
          stockError:
            'The following materials has no enough stocks to start the batch:',
          stockErrorOptions: {
            adjustQty: 'Adjust Quantity of ingredience(s)',
            addNew: 'Add new similar ingredience(s)',
            purchaseOrder: 'Make a purchase order',
            stockAdjustment: 'Make a stock adjustment',
          },
        },
        completeBatch: {
          title: 'Complete batch',
          confirmButton: 'OK, Complete Batch',
          confirm:
            'All materials amounts specified in the recipe will be deducted from the material warehouse. Do you wish to continue?',
          success: 'Batch Completed',
          stockError:
            'The following materials has no enough stocks to complete the batch:',
          stockErrorOptions: {
            adjustQty: 'Adjust Quantity of ingredience(s)',
            addNew: 'Add new similar ingredience(s)',
            purchaseOrder: 'Make a purchase order',
            stockAdjustment: 'Make a stock adjustment',
          },
        },
        deductIngredience: {
          title: 'Ingredience Deduction',
          text: 'Add new deduction for',
          confirmButton: 'OK, Deduct Now',
          cancelButton: 'Deduct Later',
          invalidDeductionAmount: 'Invalid Deduction Amount',
          generalError:
            'An error has occured deducting ingredience, please check your deduction input and try again.',
          stockError: 'The following materials has no enough stocks:',
          deductAll: {
            title: 'Deduct All Ingrediences',
            message:
              'Are you sure to deduct all ingrediences from the warehouse?',
            button: 'Deduct All Ingrediences from Warehouse',
            confirmButton: 'Deduct All',
          },
        },
        startProcedure: {
          confirm:
            'All materials amounts specified in this procedure will be deducted from the material warehouse. Do you wish to continue?',
        },
      },
      formTabs: {
        batchInformation: 'Batch Information',
        edit: 'Edit',
        details: 'Details',
        materials: 'Materials',
        log: 'Log',
      },
      statuses: {
        planned: 'Planned',
        started: 'Started',
        ongoing: 'Ongoing',
        completed: 'Completed',
      },
      table: {
        name: 'Name',
        batchNumber: 'Batch Number',
        status: 'Status',
      },
    },

    recipes: {
      title: 'Recipe',
      filters: {
        title: 'Recipe',
        all: 'All',
      },
      index: {
        title: 'Recipe',
      },
      create: {
        title: 'Add a recipe',
        success: 'Successfully Created',
      },
      edit: {
        title: 'Edit recipe',
        success: 'Successfully Updated',
        ingrediences: 'Ingrediences',
        procedures: 'Procedures',
        equipment: 'Equipment',
        addProcedure: 'Add Procedure',
        editProcedure: 'Edit Procedure',
        step: 'Step',
      },
      types: {
        beer: 'Beer',
        wine: 'Wine',
        cider: 'Cider',
        liquor: 'Liquor',
        water: 'Water',
      },
      formTabs: {
        recipeInformation: 'Recipe Information',
        ingrediencesAndProcedures: 'Ingrediences and Procedures',
        products: 'Products',
      },
    },

    recipeIngrediences: {
      index: {
        addIngrediences: 'Add Ingrediences',
        confirmDelete:
          'This will permanently delete the recipe ingredience. Continue?',
        confirmDeleteTitle: 'Delete Recipe Ingredience',
      },
    },

    equipments: {
      title: 'Equipment',
      filters: {
        title: 'Equipment',
        all: 'All',
      },
      index: {
        title: 'Equipment',
      },
      create: {
        title: 'Add equipment',
        success: 'Successfully Created',
      },
      edit: {
        title: 'Edit equipment',
        success: 'Successfully Updated',
      },
      formTabs: {
        equipmentInformation: 'Equipment Information',
      },
      table: {
        name: 'Name',
        status: 'Status',
      },
    },

    members: {
      title: 'Members',
      index: {
        products: 'Products',
        addProduct: 'Add Product',
        addMember: 'Add Member',
        tab: {
          members: 'Members',
          calendarSchedule: 'Calendar Schedule',
        },
        table: {
          members: {
            firstName: 'Firstname',
            lastName: 'Lastname',
            email: 'Email',
            color: 'Color',
            title: 'Title',
            status: 'Status',
            view: 'View',
          },
        },
        dialog: {
          cancel: 'Cancel',
          update: 'Update',
          add: 'Add',
          addMember: {
            title: 'Add member',
            firstName: 'Firstname',
            lastName: 'Lastname',
            email: 'Email',
          },
          addBooking: {
            showOrder: 'Show order',
            title: 'Add booking',
            selectProduct: 'Select product',
            selectPractitioner: 'Select practitioner',
            selectClient: 'Select client',
          },
        },
        options: {
          businessHours: 'Business Hours',
          booking: 'Booking',
        },
        calendar: {
          today: 'Today',
        },
      },
      show: {
        products: 'Products',
        addProduct: 'Add Product',
        addMember: 'Add Member',
      },
    },

    account: {
      toggleDebugMode: 'Toggle Debug Mode',
      confirmDebugMode: 'Are you sure you want to toggle debug mode?',
      onDebugMode: 'Debug mode turned on',
      offDebugMode: 'Debug mode turned off',
      switchOrganization: 'Switch Organization',
      confirmSwitchOrganization:
        'Are you sure you want to switch organization?',
      switchingOrganizationMessage: 'Redirecting to new account... Please wait',
    },

    home: {
      welcomeMsg: 'Make something awesome!',
    },

    unsubscribed: {
      success: 'You were successfully unsubscribed from the campaign.',
      error:
        "Sorry, but we couldn't unsubscribe you from the campaign. Please try again later.",
    },

    accountSetup: {
      title:
        'Welcome! Your account has been created, and a password should arrive in your email within a few minutes. \n Take a few seconds to enter your info...',
      termsError: 'You must read our Terms before registering.',
      crm: 'Customer Relationship Management(CRM)',
      invoicing: 'Order and Invoicing',
      edi: 'Electronic Data Interchange (EDI)',
      booking: 'Online Booking',
      headerMessage1: 'Your',
      headerMessage2:
        'account has been created. We sent you an email together with your password. Please let us know who you are..',
    },

    emailSetup: {
      title: "Let's get you started, what's your email address?",
      emailExistSuggestion:
        'Email already taken would you like to login instead ?',
      crm: 'Customer Relationship Management(CRM)',
      invoicing: 'Order and Invoicing',
      edi: 'Electronic Data Interchange (EDI)',
      booking: 'Online Booking',
      headerMessage1: 'Let`s get started with ',
      headerMessage2: 'Simply enter your email and you`re all set!',
      termsError: 'You must read our Terms before registering.',
    },

    registerEdi: {
      title: 'EDI',
    },

    registerOnlineBooking: {
      title: 'Online Booking',
    },

    personalInfo: {
      title: 'Personal Information',
    },

    registerDone: {
      title: 'Successfully Subscribed!',
      firstParagraph: 'Your account has been created.',
      secondParagraph1:
        "Congratulations, you have successfully registered for the 14 days trial. A email with a confirmation link has been sent to you. If you don't receive it in the next few minutes click ",
      secondParagraph2: 'here',
      secondParagraph3: 'that we will send it to you again.',
      error:
        'Could not resend the link, please contact us if the problem persist.',
      confirmationResent: 'A email confirmation has been resent successfully.',
    },

    login: {
      title: 'Login to your Kundan account',
      newUser: 'New User',
      forgotPassword: 'Forgot your password?',
      errorBoxTitle: 'Wrong login',
      inactiveAccount: 'Subscription ended, please contact support',
    },

    resetPassword: {
      title: 'Reset Password',
      firstParagraph:
        'We will send you an email with a link to reset the password.',
      successMessage: 'A email with the link has been sent.',
    },

    smsTwoFactorVerification: {
      title: 'SMS Two Factor Authentication',
      enabled: 'Enabled',
      verificationCodeSent:
        'The verification code has been sent to your mobile number',
      successMessage: 'Successfully verified code.',
      verificationCodeIncorrect: 'The code you entered is incorrect',
      enableWarningMessage:
        'To enable SMS Two Factor Authentication on your account: <br/> <br/> 1. Enter your Mobile Number and click Send Code. <br/> 2. Enter the verification code you received.',
      verifyMobileNUmber: 'Verify Your Mobile Number',
      enterMobileNUmber: 'Enter Mobile Number',
      sendCode: 'Send Code',
      resendCode: 'Resend Code',
      codeVerification: 'Verification Code',
      enterToken: 'Enter Code',
      verifyCode: 'Verify Code',
      invalidMobileNumber: 'The mobile number you entered is invalid.',
      requiredMobileNumber: 'Please enter your mobile number.',
      unableToSendVerification: 'Unable to send verification code',
      smsTwoFactorAuthEnabled:
        'SMS Two Factor Authentication has been enabled on your account.',
      google2faEnabledWarning:
        'Google Two-Factor Authentication is currently enabled on your account, only one Two-Factor Authentication module can be enabled at a time.',
    },

    googleTwoFactorVerification: {
      title: 'Google Two Factor Authentication',
      enabled: 'Enabled',
      successMessage: 'Successfully verified code.',
      verificationCodeIncorrect: 'The code you entered is incorrect',
      enableWarningMessage:
        'To enable Google Two Factor Authentication on your account:<br/><br/> <b>1. Scan the QR Code below with Google Authenticator App. <br/> 2. Enter the verification code and click Verify Code.</b>',
      codeVerification: 'Verification Code',
      enterToken: 'Enter Code',
      verifyCode: 'Verify Code',
      smsTwoFactorAuthEnabled:
        'Google Two Factor Authentication has been enabled on your account.',
      sms2faEnabledWarning:
        'SMS Two-Factor Authentication is currently enabled on your account, only one Two-Factor Authentication module can be enabled at a time.',
    },

    dashboard: {
      title: 'Dashboard',
      emailConfirmationTitle: 'Please verify your email before continuing',
      emailConfirmationText1:
        'Before you can access the account you must verify your email address.',
      emailConfirmationText2:
        'All you have todo is to check your email account. Don`t forget to check your spam folder in case the email is missing.',
      emailConfirmationText3:
        'Follow the steps in the email in order to verify you address. Do note, your passoword to Kundan is also located in the same email.',
      emailConfirmationText4:
        'Note! If you can`t find our email anywhere, you can simply request a new email by clicking the link below:',
      emailConfirmationResendButton:
        'Click here to re-send the verification email',
      emailConfirmationResendLoading: 'Sending email... please wait!',
      emailConfirmationResent: 'New verification email sent!',
      emailConfirmationText5:
        'Note! Please note it may take a few minutes untill the email appears. In case of problems, please don`t hesistate contacting us.',
      emailConfirmationResentWarning:
        'Confirmation sent, please check your inbox.',
      emailConfirmationResentError:
        "We couldn't resend your confirmation email, please try again later.",
      expiredSubscriptionWarning:
        'Your subscription has expired, please renew your plan or choose a more suitable one.',
      updateInformation: 'Please update information fields below.',
      fieldsMissing: 'Fields Missing',
      completed: 'COMPLETED',
      addWidgetBtn: 'Add widget',
    },

    bulkAddProducts: {
      selectedProducts: {
        title: 'Selected products',
        noneSelected: 'No products selected',
        productName: 'Product',
        productQty: 'Qty',
        batch: 'Batch',
        unitTypeId: 'Unit Type',
        unitQty: 'Unit Qty',
        qty: 'Qty',
        available: 'Available',
      },
      findProducts: {
        search: 'Search for product...',
      },
    },

    supplier: {
      index: {
        title: 'Supplier',
      },
      filters: {
        title: 'Suppliers',
        today: 'Today',
        all: 'All',
      },
      create: {
        title: 'Create Supplier',
        success: 'Successfully Created',
      },
      update: {
        title: 'Update Supplier',
        success: 'Successfully Updated',
      },
      edit: {
        supplier: 'Suppleir',
      },
      info: {
        phone: 'Phone Number',
        email: 'Email',
        code: 'Code',
        name: 'Name',
        streetName2: 'Street Name 2',
        streetName1: 'Street Name',
        country: 'Country',
        city: 'City',
      },
      table: {
        id: 'ID',
        number: 'Number',
        name: 'Name',
        code: 'Code',
      },
    },
    productFlow: {
      title: 'Product Flow',
      index: {
        title: 'Product Flow',
      },
      update: {
        title: 'Update Product Flow',
        success: 'Successfully Updated',
      },
      filters: {
        title: 'Product Flow',
        today: 'Today',
        all: 'All',
        view: 'View Product Flow',
      },
      create: {
        title: 'Create Product Flow',
        success: 'Successfully Created',
      },
      info: {
        title: 'Title',
        product: 'Product',
        order: 'Order Number',
        qty: 'Quantity',
        descriptions: 'Descriptions',
      },
    },

    warehouse: {
      index: {
        title: 'Warehouse',
      },
      transactionNavigation: {
        addTransaction: 'Add transaction',
        stockCount: 'Stock count',
        stockAdjustment: 'Stock adjustment',
        transfer: 'Transfer',
        purchase: 'Purchase',
      },
      filters: {
        title: 'Warehouses',
        today: 'Today',
        all: 'All',
        view: 'View Warehouses',
      },
      create: {
        title: 'Create Warehouse',
        success: 'Successfully Created',
      },
      update: {
        title: 'Update Warehouse',
        success: 'Successfully Updated',
      },
      edit: {
        supplier: 'Warehouse',
      },
      addTransaction: {
        title: 'Create transaction',
      },
      info: {
        location: 'Location',
        name: 'Name',
        isBonded: '(Bonded / Untaxed items)',
        notBonded: '(Taxed items)',
        type: 'Type',
        locked: ' (locked)',
      },
      formTabs: {
        products: 'Products',
        transactions: 'Transactions',
      },
      products: {
        noDataMsg: 'No products found',
        name: 'Product Name',
        batchName: 'Batch',
        qty: 'Quantity',
        minimumStockLevel: 'Minimum Stock Level',
        producer: 'Producer',
        hideOutOfStock: 'Hide out of stock',
        bulkDestroyProducts: 'Destroy Products',
      },
      destroyProduct: {
        success: 'Successfully marked products as destroyed',
        error: 'An error has occured processing products destruction.',
      },
      transactions: {
        noDataMsg: 'No transactions found',
        table: {
          id: 'ID #',
          qty: 'Quantity',
          via: 'Via',
          code: 'Transaction Code',
          createdAt: 'Date',
          productName: 'Product',
          beforeqty: 'Before',
          totalQty: 'Total quantity',
          afterqty: 'After',
          status: 'Status',
          client: 'Customer',
          warehouse: 'Warehouse',
          billingNumber: 'Billing Number',
          batchName: 'Batch',
        },
        filter: {
          transactionType: [
            {
              value: 'all',
              label: 'All transaction type',
            },
            {
              value: 'SO',
              label: 'Sales Order',
            },
            {
              value: 'PO',
              label: 'Purchase Ordering Recieving',
            },
            {
              value: 'PA',
              label: 'PO Recieving Adjustment',
            },
            {
              value: 'SC',
              label: 'Stock Count Adjustment',
            },
            {
              value: 'AJ',
              label: 'Adjustment',
            },
            {
              value: 'TW',
              label: 'Transfer Between Warehouse',
            },
            {
              value: 'TB',
              label: 'From Batch',
            },
            {
              value: 'TL',
              label: 'Transfer From Other Liquor Licencee',
            },
            {
              value: 'RS',
              label: 'Return Of Stock',
            },
            {
              value: 'OC',
              label: 'Order Cancel',
            },
            {
              value: 'BI',
              label: 'Batch Ingredience',
            },
            {
              value: 'PD',
              label: 'Product Destruction',
            },
            {
              value: 'TC',
              label: 'Transaction Correction',
            },
          ],
        },
      },
    },
    unitOfMeasure: {
      index: {
        title: 'Unit of Measures',
      },
      filters: {
        title: 'Unit of Measures',
        today: 'Today',
        all: 'All',
      },
      create: {
        title: 'Create Unit of Measures',
        success: 'Successfully Created',
      },
      update: {
        title: 'Update Unit of Measures',
        success: 'Successfully Updated',
      },
      edit: {
        supplier: 'Unit of Measures',
      },
      info: {
        code: 'Code',
        name: 'Name',
      },
    },

    stock: {
      noData: 'No data found.',
      index: {
        title: 'Stocks',
      },
      filters: {
        title: 'Stock Counts',
        create: 'Create Stock Counts',
        all: 'All',
      },
      create: {
        title: 'Create Stock',
        success: 'Successfully Created',
      },
      draft: {
        success: 'Successfully save draft',
        title: 'Complete Stock on draft',
      },
      view: {
        title: 'Stocks',
        details: 'stock Details',
        products: 'List Of Products',
        productsLegend: 'Product Table',
        adjustment: 'List of Adjustment',
        adjustmentLegend: 'Adjustment Table',
        detailsLegend: 'Stock Details',
      },
      info: {
        code: 'Code',
        qty: 'Total Quantity',
        warehouse: 'Warehouse',
        createdAt: 'Date Created',
        transactionDate: 'Transaction Date',
        name: 'Name',
        status: 'Status',
      },
      products: {
        sku: 'ID',
        name: 'Product Name',
        physicalCount: 'Physical Counts',
        currentCount: 'Current Counts',
        variance: 'Variance',
      },
    },

    purchase: {
      noData: 'No data found.',
      index: {
        title: 'Puchases',
      },
      filters: {
        title: 'Puchase',
        create: 'Create Puchase',
        all: 'All',
      },
      create: {
        title: 'Create Puchase',
        success: 'Successfully Created',
        unfinished: 'Unfinished',
      },
      update: {
        title: 'Update Puchase',
        success: 'Successfully Update',
        error: 'Error on updating',
      },
      cancel: {
        title: 'Cancel Puchase',
        success: 'Successfully Cancel',
        error: 'Error on cancelling',
      },
      pending: {
        title: 'Pending Puchase',
        success: 'Successfully Pending',
        error: 'Error on pending',
      },
      view: {
        title: 'Puchases',
        details: 'stock Details',
        products: 'List Of Products',
        productsLegend: 'Product Table',
        adjustment: 'List of Adjustment',
        adjustmentLegend: 'Adjustment Table',
        detailsLegend: 'Purchase Details',
        documentBtnDropdown: 'Document',
        sendPurchaseDocument: 'Email purchase document',
        downloadPurchaseDocument: 'Download purchase document',
      },
      info: {
        code: 'Code',
        qty: 'Total Quantity',
        warehouse: 'Warehouse',
        supplier: 'Supplier',
        createdAt: 'Date Created',
        name: 'Name',
        comments: 'Comments',
        status: 'Status',
        receiveDate: 'Received Date',
      },
      products: {
        sku: 'ID',
        name: 'Product Name',
        qty: 'Quantity',
        qtyReceive: 'Quantity Received',
        qtyDamage: 'Quantity Damage',
        purchasePrice: 'Purchase Price',
        costPrice: 'Cost Price',
        notes: 'Notes',
      },
      edit: {
        sendPurchaseSuccess: 'Purchase was sent successfully.',
        sendPurchaseError:
          'There was a error with the purchase, please try again later.',
      },
      status: {
        draft: 'Draft',
        progress: 'Progress',
        cancelled: 'Cancelled',
        done: 'Done',
        unfinished: 'Unfinished',
        pending_external: 'Progress External',
        pending: 'Pending',
      },
    },

    inventory: {
      title: 'Products',
      transaction: {
        title: 'Transactions',
      },
      products: {
        create: 'Create Products',
        view: 'View Products',
      },
    },

    adjustment: {
      noData: 'No data found.',
      index: {
        title: 'Stock Adjustments',
      },
      filters: {
        title: 'Stock Adjustments',
        create: 'Create Stocks Adjustment',
        all: 'All',
      },
      create: {
        title: 'Create Stock  Adjustment',
        success: 'Successfully Created',
      },
      draft: {
        success: 'Successfully save draft',
        title: 'Complete Stock  Adjustment Draft',
      },
      view: {
        title: 'Adjustment',
        details: 'Adjustment Details',
        products: 'List Of Products',
        productsLegend: 'Product Table',
        adjustment: 'List of Adjustment',
        adjustmentLegend: 'Adjustment Table',
        detailsLegend: 'Adjustment Details',
      },
      info: {
        code: 'Code',
        qty: 'Total Quantity',
        stock: 'Stock',
        warehouse: 'Warehouse',
        createdAt: 'Date Created',
        reason: 'Reason',
        status: 'Status',
        adjustmentType: 'Adjustment type',
      },
      products: {
        sku: 'ID',
        name: 'Product Name',
        qty: 'Quantity',
        exciseAdditionalCode: 'Additional Code',
      },
      statuses: {
        Adjustment: 'Adjustment',
        Wastage: 'Wastage',
        Destruction: 'Destruction',
      },
    },

    transfer: {
      noData: 'No data found.',
      index: {
        title: 'Stock Transfers',
      },
      filters: {
        title: 'Stock Transfers',
        create: 'Create Stocks Transfer',
        all: 'All',
      },
      create: {
        title: 'Create Stock  Transfer',
        success: 'Successfully Created',
      },
      draft: {
        success: 'Successfully save draft',
        title: 'Complete Stock  Transfer Draft',
      },
      view: {
        title: 'Transfer',
        details: 'Transfer Details',
        products: 'List Of Products',
        productsLegend: 'Product Table',
        Transfer: 'List of Transfer',
        transferLegend: 'Transfer Table',
        detailsLegend: 'Transfer Details',
      },
      info: {
        type: 'Type',
        code: 'Code',
        qty: 'Total Quantity',
        stock: 'Stock',
        fromWarehouse: 'From Warehouse',
        toWarehouse: 'To Warehouse',
        createdAt: 'Date Created',
        reason: 'Reason',
        status: 'Status',
        comments: 'Comments',
      },
      products: {
        sku: 'ID',
        name: 'Product Name',
        qty: 'Quantity',
        notes: 'Notes',
        batch: 'Batch',
      },
    },

    reports: {
      downloadReport: 'Download report',
      exciseEntryLabel: 'Excise entry',
      noData: 'No data found for this period.',
      clients: {
        title: 'Client Reports',
        client: 'Client',
        id: 'ID',
        balance: 'Balance ($)',
        createdAt: 'Created At',
        turnover: {
          groupButton: 'Revenue',
          viewTurnover: 'View revenue report',
          downloadTurnover: 'Download revenue report',
          emailTurnover: 'Send revenue report',
          bulk: {
            title: 'Bulksending av omsetningsrapport',
            processing: 'Behandler...',
            clients: 'Valgte kunder',
            noDataSelectedClient:
              'Please wait zip file is currently process, below list will not included in zip file.',
            noDataAllSelectedClient:
              'Unable to process due to all selected client is no data.',
            yearOf: 'Period of',
          },
        },
        clientSearch: {
          placeholder: 'e.g. name or client number',
        },
      },
      warehouse: {
        warehouse_beta: 'Stock Report Beta',
        warehouse: 'Warehouse Report',
        all: 'All Warehouses',
        transactionType: {
          all: 'All transactions',
          groupByProduct: 'Group By: Product',
        },
        warehouse_required: 'Please select a warehouse',
        month_required: 'Velg en måned',
        as_of_date: 'As of date',
        date_range: 'Date range',
        pick_date: 'Pick date',
      },
      greenDot: {
        detailed: {
          downloadDetailedReport: 'Download detailed report',
        },
      },
      exciseEntry: {
        title: 'Excise Entries',
        dateRange: {
          placeholder: 'Select the Month',
        },
        table: {
          title: 'Group',
          description: 'Description',
          totalQuantity: 'Total Quantity',
          totalVolume: 'Total',
          exciseEntries: 'Excises',
          product_name: 'Product Name',
          product_volume: 'Product Volume',
          product_basic: 'Product Excise Basic',
          product_package: 'Product Excise Package',
          order_id: 'Order ID',
          quantity: 'Quantity',
          created_at: 'Created At',
          order_customer_name: 'Customer Name',
          unitType: 'Unity Type',
          receiverName: 'Name',
        },
      },
      sales: {
        title: 'Order Report',
        exportYtd: 'Download YTD report',
        dateRange: {
          placeholder: 'Select the month',
        },
        group: {
          placeholder: 'Group by',
          names: {
            orders: 'Order',
            clients: 'Clients',
            products: 'Products',
          },
        },
        type: {
          placeholder: 'Order Type',
        },
        filter: {
          placeholder: 'Search',
          label: 'filter',
        },
        id: 'ID',
        status: 'Status',
        name: 'Name',
        sales: 'Sales ($)',
        credit: 'Credit ($)',
        total: 'Balance ($)',
        clearedInvoices: 'Amount billed',
        clearedCredit: 'Amount credited',
        export: 'Export',
      },

      aggregatedSales: {
        title: 'Aggregated Sales Report',
        export: 'Download Excel',
        includeCancelled: 'Incl. cancelled',
        dateRange: {
          placeholder: 'Select period',
        },
        groupBy: {
          placeholder: 'Group by',
          product: 'Product',
          client: 'Customer',
          clientType: 'Customer type',
          month: 'Month',
          year: 'Year',
        },
        sort: {
          placeholder: 'Sort by',
          revenueDesc: 'Revenue (high → low)',
          revenueAsc: 'Revenue (low → high)',
          volumeDesc: 'Volume (high → low)',
          volumeAsc: 'Volume (low → high)',
        },
        columns: {
          productName: 'Product',
          productNumber: 'Product no.',
          clientName: 'Customer',
          clientNumber: 'Customer no.',
          clientTypeName: 'Customer type',
          period: 'Period',
          totalRevenueNet: 'Net revenue (NOK)',
          totalRevenueGross: 'Gross revenue (NOK)',
          totalVolumeLiters: 'Volume (liters)',
          orderCount: 'Order count',
          totalQuantityUnits: 'Units',
        },
        statuses: {
          label: 'Order status',
          placeholder: 'Empty = default (confirmed, shipped, delivered, invoiced)',
          options: {
            confirmed: 'Confirmed',
            shipped: 'Shipped',
            delivered: 'Delivered',
            invoiced: 'Invoiced',
            created: 'Created',
            cancelled: 'Cancelled',
          },
        },
        summary: {
          totalRevenueNet: 'Net revenue',
          totalVolumeliters: 'Total volume',
          orderCount: 'Order count',
        },
        metrics: {
          label: 'Show columns',
        },
      },

      bills: {
        title: 'Bill Reports',
        export: 'Export',
        invoiceNumber: 'Invoice #',
        billTypeName: 'Type',
        status: 'Status',
        invoiceDate: 'Invoice Date',
        dueDate: 'Due Date',
        customer: 'Customer',
        email: 'Email',
        address: 'Address',
        sum: 'Sum',
        vat: 'Vat',
        invoiceAmount: 'Invoice Amount',
        paidAmount: 'Paid Amount',
        dueAmount: 'Due Amount',
        balance: 'Balance',
        draft: 'Draft',
        pending: 'Pending',
        sent: 'Sent',
        sending: 'Sending',
        cleared: 'Cleared',
        partlypaid: 'Partly paid',
        cancelled: 'Cancelled',
        total: 'Total',
        allClients: 'All clients',
        cash: 'Cash',
        banktransfer: 'Bank transfer',
        paid: 'Paid',
        due: 'Due',
      },
      fees: {
        skatteetaten: {
          title: 'Skatteetaten',
          due_info: 'Due 18. every month',
        },
        helsedir: {
          title: 'Helsedirektoratet',
          due_info: 'Due 18. every month',
        },
        brod: {
          title: 'Bryggeriforeningen',
          due_info: 'Due 18. every month',
        },
        infinitum: {
          title: 'Infinitum',
          due_info: 'Due 7. every month',
        },
        title: 'Fee Reports',
        export: 'Export in Excel',
        exportCsv: 'Export in Csv',
        filter: 'Filter',
        all: 'All client',
        orderNumber: 'Order #',
        client: 'Client',
        excisable: 'Excise tax?',
        productType: 'Type',
        internalItemNumber: 'Number',
        externalItemNumber: 'VP number',
        productName: 'Name',
        producerName: 'Producer',
        vintage: 'Vintage',
        alcoholPercentage: 'Alcohol (%)',
        bottleVolume: 'Bottle Volum',
        packagingType: 'Packing Type',
        corkType: 'Cork Type',
        isTaxable: 'Excise tax?',
        numberOfBottlesSold: 'Bottles sold',
        numberOfLitersSold: 'Liters sold',
        orderProducts: 'Orders',
        order_id: 'Order ID',
        quantity_confirmed: 'Quantity',
        order_date: 'Date Ordered',
        client_name: 'Client Name',
        number: 'Order Number',
        month_placeholder: 'Select a month',
        readyToCloseWarning:
          'This period is soon due and ready to be closed. Click the close button to close the period and download the reports.',
        changedWarning:
          'This period has been changed. Click the close button to close the period and download the reports.',
        closeButton: 'Close',
        confirm: {
          title: 'Close Excise Period',
          message: 'Are you sure to close this excise period?',
          button: 'Continue',
        },
        closeSuccessMessage:
          'Successfully closed excise period, you may now download your reports',
        exciseStatus: {
          ongoing: 'Ongoing',
          readyToBeClosed: 'Ready to be closed',
          changed: 'Changed',
          closed: 'Closed',
        },
      },
      brod: {
        export: 'Download Report',
      },
    },

    accountInformation: {
      title: 'Account Information',
      profile: 'Profile',
      basicInformation: 'Basic Information',
      userInformation: 'User Information',
      generalInformation: 'General',
      organizationInformation: 'Organization Information',
      businessInformation: 'Business Information',
      productInformation: 'Product Information',
      loginInformation: 'Login Information',
      addressInformation: 'Address Information',
      userSetting: 'Preferred Setting',
      contactInformation: 'Contact Information',
      passwordTitle: 'Change Password',
      accountSaveSuccess: 'The account was successfully updated.',
      passwordSaveSuccess: 'The password was successfully updated.',
      addressSaveSuccess: 'The address and contact was successfully updated.',
      general: 'General',
      email: 'Email',
      booking: 'Booking',
      accounting: 'Accounting',
      shippingProvider: 'Shipping Providers',
      project: 'Projects',
      twoFactorAuthentication: 'Two-Factor Authentication',
      advance: 'Advance',
    },

    profileAddress: {
      title: 'Address Information',
      addressSaveSuccess: 'The address was successfully updated.',
    },

    profileContact: {
      title: 'Contact Information',
      addressSaveSuccess: 'The contact was successfully updated.',
    },

    organizationSettings: {
      title: 'Settings',
      ediSettings: 'EDI Settings',
      settingsSaveSuccess:
        'The organization settings were successfully updated.',
      settingsSaveError: 'Could not save organization settings.',
      disabledFieldTooltips:
        "This field can't be changed after the first order is created.",
      disabledProductFieldTooltips:
        "This field can't be changed after the first product is created.",
      messageTemplates: 'Customize your emails',
      booking: 'Booking',
      payment_identification: 'Payment Identification',
      accounting: 'Accounting settings for export',
      coa: {
        title: 'Chart of accounts',
        noCoa: 'Chart of accounts has not yet been created',
        createCoa: 'Create COA',
        code: {
          label: 'Code',
          placeholder: 'Code',
        },
        name: {
          label: 'Name',
          placeholder: 'Name',
        },
        description: {
          label: 'Description',
          placeholder: 'Description',
        },
        orgDefault: {
          label: 'Organization default',
          none: 'None',
          receivables: 'Receivables',
          income: 'Income',
          vat: 'VAT',
          deposit: 'Deposit',
        },
      },
      ediBillingMethod: {
        options: {
          auto: 'Automatisk',
          halfAuto: 'Halv automatisk',
          manuel: 'Manuell',
        },
      },
      emailInvoiceCopy: {
        title: 'Email for invoice copy',
      },
      ediNotifyRecipients: {
        title: 'Edi Notification Recipients',
        addBtn: 'New Email',
      },
      lowStockNotifyRecipients: {
        title: 'Low Stock Notification Recipients',
        addBtn: 'New Email',
      },
      bulk_price_update: 'Bulk Price Update',
      summary: 'Summary',
      bulk_price_update_success: 'Product(s) price updated!',
      bulk_price_update_status: {
        running: {
          title: 'The bulk price update is in progress...',
          description: 'The system will automatically send an email once the process is complete. Please wait until it\'s finished before starting another update.',
        },
        failed: {
          title: 'The bulk price update has failed',
          description: 'The system encountered an issue during the process. As a result, we have aborted and reverted the changes. Please contact our support team, and we will investigate the issue. Once resolved, we will notify you and allow you to run the update again.',
        },
      },
      bulk_price_update_entries: {
        title: 'Bulk Price Update Entries/Histories',
      },
      completed: 'Completed',
      failed: 'Failed',
    },

    publicProfile: {
      title: 'Public Profile',
      profileSettings: 'Profile Settings',
      mainSettings: 'MAIN SETTINGS',
      checkoutSettings: 'Checkoutsettings',
      connectToStripe: 'Connect Stripe',
      stripeConnected: 'Stripe connected',
      defaults: 'DEFAULTS',
      profileUrl: 'Profile Url',
      updateSucess: 'The public profile was successfully updated.',
    },

    businessHours: {
      title: 'Businesshours',
      businessHoursTitle: 'Open hours',
      businessHourExceptionsTitle: 'Exceptional hours',
      exceptionalHoursSaveKeep: 'Keep em',
      exceptionalHoursSaveCancel: 'Cancel em',
    },

    clientGroups: {
      index: {
        title: 'Client Groups Overview',
        clientsCount: ' clients',
        confirmDelete: 'This will permanently delete the group. Continue?',
        confirmDeleteTitle: 'Delete Client Group',
        deleteHasClientsError: 'Cannot delete group with clients in it.',
        deleteError: 'Client group could not be deleted.',
      },
      create: {
        title: 'Add Client Group',
        success: 'Client Group added successfully!',
      },
      edit: {
        title: 'Edit Client Group',
        success: 'Client Group updated successfully!',
      },
    },

    clients: {
      organizationNumber: 'Fetch data from Brreg',
      info: {
        clientNumber: 'Client #:',
        organizationNumber: 'Organization number:',
        billType: 'Bill type:',
        phone: 'Phone:',
        email: 'Email:',
        totalOrders: 'Total Orders:',
        totalRevenue: 'Total Revenue:',
        pendingPayments: 'Pending Payments:',
        clientType: 'Client Type:',
        isProducer: 'Is Producer:',
        clientGroup: 'Client Group:',
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneNumber: 'Phone Number:',
        mobileNumber: 'Mobile Number:',
        streetName: 'Street Name:',
        secondStreetName: 'Second Street Name:',
        postalCode: 'Postal Code:',
        city: 'City:',
        orders: 'Orders',
        bills: 'Bills',
        totalBought: 'Total invoiced',
        totalPending: 'Total invoiced, not paid',
        systemGenerated: 'System generated',
        ehfInvoiceSupport: 'EHF invoicing (Peppol)',
        ehfSupport: {
          yes: 'Yes — registered for EHF billing 3.0 in Peppol directory',
          no: 'No — not registered for EHF 3.0 (save customer after org. no. to re-check)',
          needsOrgNumber: 'Cannot verify — add organization number',
        },
        ehfListLabel: 'EHF (Peppol)',
        ehfListVerified: 'Verified for EHF invoicing',
        ehfListNotVerified: 'Not verified for EHF invoicing',
        value: {
          billType: {
            options: {
              single: 'Single',
              consolidate: 'Consolidate',
            },
          },
        },
      },
      index: {
        bulkMaxLimitExceededError:
          'The maximum invoices selection for bulk action is up to',
        editTooltip: 'Edit Client Profile',
        deleteTooltip: 'Delete Client',
        title: 'Clients Overview',
        confirmDelete:
          'This will permanently delete the client and its orders. Continue?',
        confirmDeleteTitle: 'Delete Client',
        downloadAllClients: 'Download All Clients',
        importClients: 'Drag and drop excel file here to import clients...',
        importClientsErrorMessage:
          'An error has occured during import. Please check your file and try again.',
        importClientsSuccessMessage: 'Successfully imported clients.',
        importData: 'Import Data',
        exportData: 'Export Data',
        phoneNumber: 'Phone Number',
        email: 'Email',
        sortName: {
          placeholder: 'Sorter',
        },
        search: {
          placeholder: 'Search by name, email or organization number',
        },
        listing: {
          placeholder: 'Select Type',
        },
      },
      table: {
        name: 'Name',
        custNo: 'Customer No.',
        organizationNumber: 'Org. no.',
        billType: 'Bill Type',
        phone: 'Phone',
        email: 'Email',
        ehf: 'EHF',
        ordersCount: 'Orders count',
        createdAt: 'Created',
        parentClient: 'Parent client',
        billMainParent: 'Bill main parent',
      },
      delete: {
        title: 'Warning',
        confirm:
          'Do you wish to delete this customer? Customers with orders cannot be deleted.',
        success: 'Customer deleted',
      },
      create: {
        title: 'Add Client',
        success: 'Client added successfully!',
        brrig: {
          warning: 'Organization not found',
        },
        gotoEdit: 'Do you want to add more details?',
        addMore: 'Create a new client',
        gotoIndex: "I'm good, take me to the client index",
      },
      edit: {
        title: 'Edit Client',
        clientInfo: 'Client Information',
        success: 'Client updated successfully!',
        overview: 'Overview',
        clientOrders: 'Client Orders',
        latestOrders: 'LATEST ORDERS',
        latestBills: 'LATEST BILLS',
        recentActivities: 'RECENT ACTIVITIES',
        viewAll: 'VIEW ALL',
        allBills: 'All Bills',
        bills: 'BILLS',
        allActivities: 'All Activities',
        activities: 'ACTIVITIES',
        allOrders: 'All Orders',
        orders: 'ORDERS',
        editInformation: 'Edit Information',
        totalOrders: 'TOTAL ORDERS',
        totalBills: 'TOTAL BILLS',
        totalActivities: 'TOTAL ACTIVITIES',
        noActivity: 'No Activity',
        errorNoClient: 'Please choose the client',
        glnSuccess: 'GLN number and coordinates is available, see the fields.',
        glnError: 'GLN number and coordinates is not found!, please check your organization number.',
      },
      catalogues: {
        title: 'Catalogues',
        sendCatalogue: 'Send Catalogue',
        actionCodes: {
          add: 'Add',
          update: 'Update',
          replace: 'Replace',
          delete: 'Delete',
        },
      },
    },

    productGroups: {
      formTabs: {
        groupInformation: 'Group Information',
        pricingOptions: 'Pricing Options',
      },
      filters: {
        title: 'Product Groups',
        latest: 'Latest',
        pastMonth: 'Past Month',
        all: 'All',
      },
      index: {
        title: 'Product Groups Overview',
        productsCount: ' products',
        confirmDelete: 'This will permanently delete the group. Continue?',
        confirmDeleteTitle: 'Delete Product Group',
        deleteHasProductError: 'Cannot delete group with products in it.',
        deleteError: 'Product group could not be deleted.',
      },
      create: {
        title: 'Add Product Group',
        success: 'Product group added successfully',
      },
      edit: {
        title: 'Edit Product Groups',
        success: 'Product group edited successfully',
      },
    },

    productPackagings: {
      formTabs: {
        packagingInformation: 'Packaging Information',
        pricingOptions: 'Pricing Options',
      },
      filters: {
        title: 'Product Packagings',
        latest: 'Latest',
        pastMonth: 'Past Month',
        all: 'All',
      },
      index: {
        title: 'Product Packagings Overview',
        productsCount: ' products',
        confirmDelete: 'This will permanently delete the packaging. Continue?',
        confirmDeleteTitle: 'Delete Product Packaging',
        deleteHasProductError: 'Cannot delete packaging with products in it.',
        deleteError: 'Product packaging could not be deleted.',
      },
      create: {
        title: 'Add Product Packaging',
        success: 'Product packaging added successfully',
      },
      edit: {
        title: 'Edit Product Packagings',
        success: 'Product packaging edited successfully',
        delete: 'Product packaging deleted',
      },
    },

    productTags: {
      formTabs: {
        tagInformation: 'Tag Information',
      },
      index: {
        title: 'Product Tags',
        productsCount: ' products',
      },
      filters: {
        title: 'Product Tags',
        all: 'All',
      },
      create: {
        title: 'Add Product Tag',
        success: 'Product Tag added successfully',
      },
      edit: {
        title: 'Edit Product Tag',
        success: 'Product Tag edited successfully',
      },
    },
    priceFields: {
      formTabs: {
        tagInformation: 'Field Information',
      },
      index: {
        title: 'Price Field',
        productsCount: ' products',
      },
      filters: {
        title: 'Price Fields',
        all: 'All',
      },
      create: {
        title: 'Add Price Field',
        success: 'Product Price Field successfully',
      },
      edit: {
        title: 'Edit Price Field',
        success: 'Price Field edited successfully',
      },
    },
    campaigns: {
      listNotSetup:
        'Please set up list on this campaign otherwise news will not sent!',
      noDataMsg: 'No campaign email found',
      index: {
        title: 'Campaigns Overview',
        description: 'Description',
        campaignType: 'Type',
        confirmDelete: 'This will permanently delete the campaign. Continue?',
        confirmDeleteTitle: 'Delete Campaign',
        deleteHasClientsError: 'Cannot delete campaign with emails in it.',
        deleteError: 'Campaign could not be deleted.',
      },
      create: {
        title: 'Add Campaign',
        tabTitle: 'Campaing information',
        campaignTypeTooltip:
          'Sequence: test description. <br/><br/> Broadcast: test description.',
      },
      edit: {
        title: 'Edit Campaign',
        campaignInfo: 'Campaign Information',
        overview: 'Campaign Overview',
        emails: 'Emails',
        emailBodyTooltip:
          'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}',
        clients: 'Clients',
        totalSubscribers: 'Subscribers',
        unsubscribed: 'Unsubscribed',
        bounced: 'Bounced',
        latestSubscribers: 'Latest Subscribers',
        latestUnsubscribed: 'Latest Unsubscribed',
        latestBounced: 'Latest Bounced',
        viewAll: 'View All',
        updateSuccess: 'Campaign updated successfully.',
        removeClientError: 'Client could not be removed from campaign.',
        addClients: {
          placeholder: 'Select clients',
        },
        addClientGroups: {
          placeholder: 'Select client groups',
        },
        emailTracking: {
          noDataMsg: 'No record found',
          dateRange: 'Date range:',
          countLabel: {
            opened: 'Opened',
            delivered: 'Delivered',
            clicked: 'Clicked',
            dropped: 'Dropped',
            bounced: 'Bounced',
            complained: 'Complained',
            failed: 'Failed',
            unsubscribed: 'Unsubscribed',
          },
          graphLabel: 'Graph',
          recipientLabel: 'Recipients',
          noRecipientAvailable: 'No recipients available',
          dateRangDropDown: {
            group1: 'Text with icon',
            today: 'Today',
            all: 'All',
            group2: 'Line chart',
            dateRange: 'Date range',
          },
          datePicker: {
            shortcut: {
              last3Days: 'Last 3 days',
              lastWeek: 'Last week',
              lastMonth: 'Last Month',
              last3Month: 'Last 3 Months',
            },
          },
        },
      },
    },

    subscriberList: {
      index: {
        title: 'List Overview',
        description: 'Description',
        confirmDelete: 'This will permanently delete the list. Continue?',
        confirmDeleteTitle: 'Delete List',
        deleteError: 'List could not be deleted.',
        topInfo: 'List info.',
        fromEmail: 'Email',
        fromName: 'Name',
        emailCount: 'Email count',
      },
      create: {
        title: 'Create List',
        tabTitle: 'List Information',
      },
      edit: {
        sendingEmailLoading:
          'We are sending optin link for each emails, please wait...',
        filterLabel: 'Filter by:',
        tab1Title: 'Subscribers',
        tab2Title: 'Setting',
        tab3Title: 'Rules',
        title: 'Edit Subscriber List',
        overview: 'Subscriber List Overview',
        totalSubscribers: 'Subscribers',
        unsubscribed: 'Unsubscribed',
        latestSubscribers: 'Latest Subscribers',
        latestUnsubscribed: 'Latest Unsubscribed',
        viewAll: 'View All',
        deleteList: 'Delete List',
        delete: 'Delete',
        deleteConfirmHeaderMsg: 'Warning',
        deleteConfirmBodyMsg:
          'Do you wish to delete this list?, This list will permanently deleted.',
        addClients: {
          placeholder: 'Select clients',
        },
        addClientGroups: {
          placeholder: 'Select client groups',
        },
        subscribers: {
          subscribeSwitchTooltip: 'Currently: subscirbed',
          unsubscribeSwitchTooltip: 'Currently: unsubscribe',
          delete: 'Delete',
          deleteConfirmHeaderMsg: 'Warning',
          deleteConfirmBodyMsg:
            'Do you wish to delete this email?, This email will no longer part of this list.',
          alreadyInList: ' - already in this list',
          subscribeConfirmHeaderMsg: 'Warning',
          subscribe: 'Subscribe',
          unsubscribe: 'Unsubscribe',
          ableToReceive:
            'Do you wish to subscribe this email? This email will receive newsletter.',
          unableToReceive:
            'Do you wish to unsubscribe this email? This email will no longer receive newsletter.',
          ableToReceiveAll:
            'Do you wish to subscribe all emails? All emails will receive newsletter.',
          unableToReceiveAll:
            'Do you wish to unsubscribe all emails? All emails will no longer receive newsletter.',
          groupModalHeaderTitle: 'Client Group:',
          groupModalCancel: 'Cancel',
          groupModalApply: 'Apply',
        },
        filters: {
          all: 'All',
          unsubscribe: 'Unsubscribe',
        },
      },
    },

    news: {
      index: {
        title: 'Emails overview',
        confirmDelete: 'This will permanently delete the email. Continue?',
        confirmDeleteTitle: 'Delete Email',
        deleteError: 'Email could not be deleted.',
      },
      create: {
        title: 'Create Email',
        createSucess: 'Email created successfully.',
        sendTestSucess: 'Test email sent!',
      },
      edit: {
        title: 'Edit Email',
        updateSucess: 'Email updated successfully.',
      },
    },

    products: {
      types: {
        product: 'Product',
        bundle: 'Bundle',
        child: 'Child',
        service: 'Service',
        plan: 'Plan',
        beverage: 'Beverage',
        beer: 'Beer',
        mead: 'Mead',
        wine: 'Wine',
        liquor: 'Liquor',
        cider: 'Cider',
        carbonated: 'Carbonated',
        nonCarbonated: 'Non-carbonated',
        material: 'Material',
        alcohol: 'Alcohol',
        nonAlcohol: 'Non-Alcohol',
        lightWine: 'Light Wine',
        strongWine: 'Strong Wine',
        redWine: 'Red Wine',
        sparklingWine: 'Sparkling Wine',
      },
      formTabs: {
        productInformation: 'Product Information',
        productIndentification: 'Product Identification',
        pricingOptions: 'Product details',
        inventory: 'Inventory',
        transactions: 'Transactions',
        transactionsv2: 'Transactions V2',
        mergeProduct: 'Merge Product',
        childProducts: 'Child Products',
        syncDetails: 'Sync Details',
      },
      filters: {
        title: 'Products',
        latest: 'Latest',
        pastMonth: 'Past Month',
        all: 'All',
        withDeposit: 'With Deposit',
        active: 'Active',
        deactivated: 'Deactived',
        asko: 'Available Asko',
        vinhuset: 'Available Vinhuset',
        marketplace: 'Available DrikkeRiket',
        onlineStore: 'Available Online Store',
        materials: 'Materials',
        placeholder: 'Select Filter',
        type: 'Type',
        producer: 'Producer',
        alcohol: 'Alcohol',
        alcoholFree: 'AlcoholFree',
      },
      labels: {
        priceAndTax: 'Price and tax',
        productDetails: 'Product details',
        mergeProduct: 'Merge Product',
        childProducts: 'Child Products / Variations',
        productInformation: 'Product Information',
        productIndentification: 'Product Identification',
        priceForm: 'Price and tax',
        detailsForm: 'Product details',
        exciseForm: 'Excise details',
        packagingForm: 'Packaging details',
        fieldPrice: 'Price Fields',
        marketplace: 'Marketplace Selling',
        alcohol: 'Alcohol',
        alcoholFree: 'AlcoholFree',
        onlineStore: 'Online Store',
      },
      index: {
        title: 'Products Overview',
        confirmDelete: 'This will permanently delete the product. Continue?',
        confirmDeleteTitle: 'Delete Product',
        downloadAllProducts: 'Download All Products',
        importProducts: 'Drag and drop excel file here to import products...',
        importProductsErrorMessage:
          'An error has occured during import. Please check your file and try again.',
        importProductsSuccessMessage: 'Successfully imported products.',
        importProductsErrorPopupTitle: 'The import encountered some errors:',
        importData: 'Import Data',
        exportData: 'Export Data',
        row: 'Row',
      },
      create: {
        title: 'Add Product',
        success: 'Product added successfully',
        options: {
          edit: 'Do you want to add more details?',
          addMore: 'Create a new product',
          gotoIndex: "I'm good, take me to the product index",
        },
        vmp: {
          fetch: 'Sync from VMP',
        },
      },
      syncVmp: {
        title: 'Sync Vinmonopolet Products',
        validatingData: 'Validating Data...',
        added: 'Added',
        updated: 'Updated',
        noDataToBeSynced: 'We found no new data to sync.',
        syncSuccess: 'Sync Successful.',
        syncError: 'An error occurred during sync.',
        inputRequired: 'Vinmonopolet number is required',
        noModuleWarning:
          'Please go to the <a href="/#/modules" target="_blank">"Modules"</a> page and enable Vinmonopolet to continue.',
        existingProducts: 'Existing products',
        newProducts: 'New products',
        syncFieldTitle: 'Select Fields to Sync',
        fields: {
          name: 'Name',
          type: 'Product type',
          subtype: 'Product Subtype',
          retailPriceVmp: 'Retail Price VMP',
          producer: 'Producer',
          country: 'Country',
          vintage: 'Vintage',
          alcohol_percentage: 'Alcohol Percentage',
          bottle_volume: 'Bottle Volume',
          cork_type: 'Cork Type',
          packaging_material: 'Packaging Material',
          gtin: 'GTIN',
          colour: 'colour',
          odour: 'Odour',
          region: 'Region',
          subRegion: 'SubRegion',
          sugar: 'Sugar',
          acid: 'Acid',
          fullness: 'Fullness',
          freshness: 'Freshness',
          tannins: 'Tannins',
          bitterness: 'Bitterness',
          sweetness: 'Sweetness',
          taste: 'Taste',
          recommendedFood: 'Recommended Foods',
          storagePotential: 'Storage Potential',
          ingredients: 'Ingredients',
          organic: 'Organic',
          biodynamic: 'Biodynamic',
          locallyProduced: 'Locally Produced',
          environmentallySmart: 'Environmentally Smart',
          freeOrLowOnGluten: 'Free Or Low On Gluten',
          kosher: 'Kosher',
        },
      },
      edit: {
        title: 'Edit Product',
        success: 'Product edited successfully',
        error: 'Product edited failed to update',
      },
      delete: {
        title: 'Warning',
        confirm: 'Delete this product?',
        success: 'Product successfully deleted',
        imageConfirm: 'Delete this product image?',
        imageSuccess: 'Product image successfully deleted',
      },
      merge: {
        success: 'Product successfully merged',
      },
      warehouse: {
        noDataMsg: 'No warehouse found',
        table: {
          qty: 'Quantity',
          name: 'Warehouse',
          warehouseId: 'Warehouse #',
          batchName: 'Batch',
        },
      },
      transactions: {
        noDataMsg: 'No transactions found',
        table: {
          qty: 'Quantity',
          via: 'Via',
          status: 'Status',
          client: 'Customer',
          warehouse: 'Warehouse',
          billingNumber: 'Billing Number',
          createdAt: 'Date',
          id: 'ID #',
          productName: 'Product',
          batchName: 'Batch',
          beforeqty: 'Before',
          afterqty: 'After',
        },
      },
      table: {
        id: 'ID',
        price: 'Price',
        name: 'Name',
        qty: 'Quantity',
        warehouses: 'Warehouse',
        number: 'Number',
        description: 'Description',
        case: 'Case',
        loose: 'Loose',
        total: 'Total',
      },
      indexSettings: {
        displayType: 'Display Type',
        groupBy: 'Group By',
        views: {
          grid: 'Grid',
          list: 'List',
        },
        groups: {
          None: 'None',
          Producer: 'Producer',
          Type: 'Type',
        },
      },
    },
    bills: {
      billLines: 'Bill lines',
      formTabs: {
        invoiceInformation: 'Invoice Information',
        edit: 'Edit invoice',
        emails: 'Emails',
        reminders: 'Reminders',
      },
      message: {
        delete: 'Do you want to delete this export?',
        title: 'Delete Confirmed',
      },
      filters: {
        title: 'Invoices',
        today: 'Today',
        upcoming: 'Upcoming',
        pending: 'Pending',
        sent: 'Sent',
        overdue: 'Overdue',
        cancelled: 'Cancelled',
        paid: 'Paid',
        partlyPaid: 'Partly Paid',
        all: 'All',
        creditNote: 'Credit Note',
        invoice: 'Invoice',
      },
      index: {
        remainingToPay: 'remaining to pay',
        bulkMaxLimitExceededError:
          'The maximum invoices selection for bulk action is up to',
        title: 'Bills Overview',
        confirmDelete: 'This will permanently delete the bill. Continue?',
        confirmDeleteTitle: 'Delete Bill',
        clientName: 'Client',
        deleteError: 'Bill could not be deleted.',
        deleteNotDraftError: 'Only drafts can be deleted.',
        billStatus: 'Status',
        dueDateFormated: 'Due Date',
        invoiceDateFormated: 'Invoice Date',
        billType: 'Type',
        quantities: 'qty',
        confirmActionTitle: 'Confirm',
        confirmAction1: 'Are you sure you want to proceed with',
        confirmAction2: 'on all the',
        confirmAction3: 'selected bills',
        email: 'Email',
        ehf: 'Ehf',
        paid: 'Paid',
        sent: 'Sent',
        edi: 'Edi',
        action: {
          markBilledAsPaid: 'Mark Billed as Paid',
        },
        overdueBadge: 'Overdue',
      },
      table: {
        id: 'ID',
        name: 'Invoice #',
        type: 'Type',
        status: 'Status',
        client: 'Customer',
        amountDue: 'Amount due',
        amountPaid: 'Amount paid',
        totalGross: 'Total gross',
        dueDate: 'Due date',
        invoiceDate: 'Invoice date',
      },
      create: {
        title: 'Add Bill',
        success: 'Bill created successfully!',
        orderError: 'Only one bill can be created per order',
      },
      exportBill: {
        title: 'Export Bill',
        btn: 'Create',
        confirmSuccess: 'Successfully created export',
        error: 'Internal Error',
        providerNotSet: 'Please select accounting provider',
        datePeriod: 'Select period',
        description: {
          label: 'Description',
          placeholder: 'Enter your description',
        },
        billsDateRange: {
          placeholder: 'Select the Date Range',
          placeholderStart: 'Start date',
          placeholderEnd: 'End date',
          label: 'Select period',
        },
        download: {
          periode: 'Periode',
          description: 'Description',
          provider: 'Provider',
          download: 'Download',
          noData: 'No data found',
        },
      },
      edit: {
        orderReference: 'Order Reference',
        title: 'Edit Bill',
        detailsLegend: 'Bill Details',
        billStatus: 'Status',
        sourceOrder: 'Source Order',
        sourceBill: 'Source Bill',
        customerDetails: 'Customer Details',
        address: 'Address',
        updateSuccess: 'The bill was updated successfully.',
        sendPreviewInfo: 'Please wait',
        creditNoteTitle: 'Edit Credit Note',
        showInvoiceBtn: 'Show Invoice',
        downloadInvoiceBtn: 'Download Invoice',
        showCreditNoteBtn: 'Show Credit Note',
        downloadCreditNoteBtn: 'Download Credit Note',
        sendInvoiceBtn: 'Send invoice by email',
        sendEdiInvoiceBtn: 'Send invoice (EDI)',
        sendEdiCreditNoteBtn: 'Send credit note (EDI)',
        sendEhfInvoiceBtn: 'Send EHF',
        sendInvoiceEmailFallbackBtn: 'Send invoice by email (differs from customer preference)',
        sendCreditNoteEmailFallbackBtn: 'Send credit note by email (differs from customer preference)',
        ehfNotVerifiedTitle: 'EHF is not ready for this customer',
        ehfNotVerifiedBody:
          'This customer has EHF as the billing method, but Peppol verification (EHF billing 3.0) is not recorded. Update the customer (save again) or send by email temporarily.',
        ehfNotVerifiedClientLink: 'Open customer',
        ehfNotVerifiedNoEmail:
          'The customer has no email address; add one on the customer card before you can send by email.',
        ehfPreferredOverEmailTitle: 'This customer can receive EHF',
        ehfPreferredOverEmailBody:
          'The billing method is set to email, but the customer is verified for EHF (Peppol). For most B2B invoices, EHF is preferred. You can send via EHF now, or use email if you still need to.',
        ehfPreferredOverEmailNoEmail:
          'Without a customer email you cannot send by email here — add an email on the customer card, or send via EHF.',
        ehfPreferredOverEmailSendEhfBtn: 'Send with EHF (recommended)',
        ehfPreferredOverEmailSendInvoiceEmailBtn: 'Send invoice by email',
        ehfPreferredOverEmailSendCreditNoteEmailBtn: 'Send credit note by email',
        ehfModuleUpsellTitle: 'Enable the EHF module for this customer',
        ehfModuleUpsellTitleNoPeppolYet: 'Enable the EHF module first',
        ehfModuleUpsellBody:
          'This customer is verified for EHF (Peppol), but the EHF module is not enabled on your account. With EHF you can send B2B invoices electronically instead of email — often faster and more reliable.',
        ehfModuleUpsellBodyNoPeppolYet:
          'This customer has EHF as the billing method, but the EHF module is not enabled on your account. Enable the module to send via EHF. You can then save the customer again for Peppol verification if needed, or send by email temporarily.',
        ehfModuleUpsellLink: 'Click here to enable the EHF module',
        ehfModuleUpsellUnavailable: 'The EHF module is not available right now. Contact support if you need help.',
        resendInvoiceBtn: 'Resend',
        sendReminder: 'Send Reminder',
        overdueInvoiceNotice:
          'This invoice is past its due date. Open the Reminders tab to send a payment reminder by email.',
        overdueBadge: 'Overdue',
        invoiceWithReminderFee: 'Reminder PDF',
        invoiceSent: 'Invoice sent',
        sendCreditNoteBtn: 'Send credit note by email',
        sendInvoiceSuccess: 'Invoice was successfully queued for sending.',
        sendInvoiceError:
          'There was a error with the invoice, please try again later.',
        createCreditNoteBtn: 'Credit Note',
        createNoteError:
          'There was a error with the credit note, please try again later.',
        creditNoteProducttitle: 'Credit Note Products',
        noCreditNoteSource: 'No credit note source available',
        noClientEmailNoInvoice: 'Client does not have email to send invoice.',
        invoice: 'Invoice',
        creditnote: 'Credit Note',
        creditNoteReason: 'Creditnote reason',
        to: 'To',
        from: 'From',
        subject: 'Subject',
        messageBody: 'Message Body',
        notes: 'Notes',
        attachment: 'Attachment',
        order: 'Order',
        date: 'Date',
        paymentDate: 'Payment Date',
        dueDate: 'Due Date',
        invoiceNumber: 'Invoice #',
        cc: 'Send a copy to',
        deliveredTo: 'Delivered to',
        validateKidNumber: 'Validate KID',
        generateKidNumber: 'Generate KID',
        kidGenerateSuccess: 'Updated',
        validKID: 'KID valid',
        invalidKID: 'KID invalid',
        emailTracking: {
          delivered: 'Delivered',
          opened: 'Opened',
          clicked: 'Clicked',
          dropped: 'Dropped',
          bounced: 'Bounced',
          complained: 'Complained',
          failed: 'Failed',
          recipient: 'Recipient',
          date: 'Date',
          type: 'Type',
          device: 'Device',
        },
      },
      crediNoteReason: {
        title: 'Tell us why you are making this credit note',
      },
    },

    appointments: {
      index: {
        title: 'Appointments Overview',
        futureFilter: 'From today on',
        cancelled: 'Cancelled',
        completed: 'Completed',
        created: 'Created',
        ongoing: 'Ongoing',
        noSlots: 'No slots available for the day.',
        freeSlot: 'Free slot!',
        nothingScheduled: 'Nothing scheduled.',
        exception: 'Exception',
        displayWeekend: 'Display Weekend',
        week: 'Week',
      },
      create: {
        title: 'Add Appointment',
      },
      edit: {
        title: 'Edit Appointment',
        editButton: 'Go to Overview',
        destroyError: 'Sorry, we could not cancel this appointment.',
      },
    },

    shippingProviderAll: 'All providers',

    orderPickups: {
      title: 'Order pickups',
      filter: {
        label: 'Filter by',
      },
      tableHead: {
        order: 'Order',
        status: 'Status',
        customer: 'Customer',
        shippingProvider: 'Shipping provider',
      },
      table: {
        number: 'Order #',
        createdAt: 'Created at',
        pickupDate: 'Pickup date',
        pickupBy: 'Pickup by',
        shippingProvider: 'Shipping provider',
        shippingDate: 'Shipping date',
        tracking: 'Tracking',
        openTracking: 'Open tracking',
        noTracking: 'No tracking registered yet',
        deliveryDate: 'Delivery date',
        missing: 'Missing',
        noData: 'No available data',
      },
      index: {
        shippingStatuses: {
          all: 'All status',
          new: 'New',
          picked: 'Picked',
          shipped: 'Shipped',
          delivered: 'Delivered',
          cancelled: 'Cancelled',
        },
      },
    },

    orders: {
      types: {
        all: 'All',
        product: 'Product',
        edi: 'EDI',
        appointment: 'Appointment',
        sale: 'Sale',
        return: 'Return',
        wordpress: 'Drikkeriket',
        transfer: 'Transfer',
      },
      shippingConfirm: {
        title: 'Confirmed Shipping',
        unassignedProductWarning:
          'There are still unassigned products to the package.',
        unassignedProductError:
          'You need to assign ALL the products to continue.',
        manageDelivery: 'Manage Delivery',
        shippingProviderRequired: 'Shipping provider is required',
        addShippingProviderBtn: 'Click here to add shipping provider options',
      },
      orderTable: {
        productErrorMessage: 'Product not found',
      },
      orderConfirm: {
        title: 'Confirm Order',
        znbTitle: 'Set Excise',
        exciseWarningMessage:
          'There are beverage product(s) in this order with missing excise. Click the product link in the table to set it up.',
        upsellMessage:
          "You're selling beverage product. Make your life easier by subscribing to the excise module. Contact us at support@kundan.no for a free trial",
        clientType: 'Client type',
        excisable: 'Excisable',
        nonExcisable: 'Non Excisable',
        exciseCode: 'Excise code',
        exciseCheck: 'Excise Check',
        paidExcise: 'Paid Excise',
        paidExciseYes: 'PAID',
        paidExciseNo: 'UNPAID',
        packagingCheck: 'Packaging',
        table: {
          product: 'Product',
          excise: 'Excisegroups',
          exciseGroup: {
            beverage: 'Beverage',
            packaging: 'Packaging',
            basic: 'Basic',
          },
          bottleVolume: 'Volume (ℓ)',
          alcoholPercentage: 'Alkohol %',
        },
        orderConfirmNotification: 'Send an order confirm notificaiton to client',
      },
      orderWarehouse: {
        title: 'Order Warehouse',
      },
      orderInternalNote: {
        title: 'Internal note',
      },
      purchaseReceive: {
        title: 'Received Purchase',
      },
      status: {
        undefined: 'Undefined',
        created: 'New',
        Done: 'Done',
        done: 'Done',
        confirmed: 'Confirmed',
        processed: 'Processed',
        received: 'Received',
        completed: 'Completed',
        invoiced: 'Invoice created',
        invoiced_externally: 'Invoiced externally',
        bill_sent: 'Invoiced',
        credited: 'Credit Noted',
        cancelled: 'Cancelled',
        shipping_confirmed: 'Shipping Confirmed',
        invoiced_consolidated: 'Invoiced Consolidated',
        waiting_autobilling: 'Waiting Auto-Billing',
        picked: 'Order picked',
        shipped: 'Order sent',
        delivered: 'Order delivered',
        vipps_processing: 'Vipps Processing',
      },
      formTabs: {
        orderInformation: 'Order Information',
        deliveryNote: 'Delivery Information',
        edit: 'Edit Order',
        events: 'Order Events',
      },
      orderLines: 'Order lines',
      index: {
        bulkMaxLimitExceededError:
          'The maximum order selection for bulk action is up to',
        editTooltip: 'Edit Order',
        deleteTooltip: 'Delete Order',
        title: 'Orders Overview',
        confirmDelete: 'This will permanently delete the order. Continue?',
        confirmDeleteTitle: 'Delete Order',
        clientName: 'Client',
        orderType: 'Order Type',
        activity: 'Activity',
        start: 'Start',
        service: 'Service Name',
        cancelled: 'Cancelled',
        confirmCancel: 'This will cancel the order. Continue?',
        confirmCancelTitle: 'Cancel Order',
        status: 'Status',
        ediNumber: 'EDI Number',
        deliveryDate: 'Delivery Date',
        pickupDate: 'Pickup Date',
        client: 'Client',
        items: 'Items',
        type: 'Type',
        qty: 'Qty',
        referenceNumber: 'Order Reference',
        createdDate: 'Ordre created',
      },
      table: {
        id: 'ID',
        name: 'Number',
        type: 'Type',
        status: 'Status',
        clientName: 'Customer',
        totalValue: 'Amount',
        totalQuantity: 'Quantity',
        createdDate: 'Date',
        amountDue: 'Amount due',
        amountPaid: 'Amount paid',
        totalGross: 'Total gross',
      },
      create: {
        title: 'Add Order',
      },
      edit: {
        orderReference: 'Order Reference',
        returnOrderComplete: 'Return Order completed',
        modalFormTitle: 'QUICK PRODUCT EDIT',
        exciseModalFormTitle: 'Update Excise for',
        title: 'Edit Order',
        detailsLegend: 'Order Details',
        ediTitle: 'EDI Order Information',
        billsAndCreditNotes: 'Bills and Credit Notes from this order',
        bill: 'Bill',
        creditNote: 'Credit Note',
        customerDetails: 'Customer Details',
        address: 'Address',
        successMessage: 'Order updated!',
        orderProducttitle: 'Order Products',
        noProductWarning: 'No products on this order yet.',
        addProductButton: 'Add product',
        subtotal: 'Subtotal',
        discount: 'Discount',
        tax: 'Tax',
        deposit: 'Deposit',
        rounding: 'Rounding',
        total: 'Total',
        quantityError: 'Quantity cannot be 0.',
        priceError: 'Price cannot be 0.',
        productErrorMessage: 'Product not found',
        orderType: 'Order Type',
        client: 'Client',
        createBillButton: 'Create Bill',
        missingEdiDetails: 'Missing EDI details, please contact suppport.',
        cancelError: 'Order could not be cancelled.',
        cancelSuccess: 'Order(s) has been successfully cancelled.',
        returnSuccess: 'Order(s) has been successfully returned.',
        pleaseConfirmAllOrderProducts:
          'Please confirm the quantities of the order products before proceeding.',
        pleaseLinkTheSourceOrder:
          'Please link the EDI Order source for this order.',
        quantityMustNotBeGreaterThanQuantityOrdered:
          'Quantity confirmed cannot exceed the quanity ordered',
        originalOrderItems: 'Original Order Items',
        orText: 'or',
        roundInvoiceTotal: 'Round Invoice Total',
        storeName: 'Store Name',
        storeAddress: 'Store Address',
        requestedDeliveryDate: 'Requested Delivery Date',
        confirmedDeliveryDate: 'Confirmed Delivery Date',
        pickupDate: 'Pickup Date',
        shippingProvider: 'Shipping Method',
        trackingNumber: 'Tracking Number',
        trackingUrlNotAvail: 'Tracking url not available',
        company: 'Company',
        name: 'Name',
        appointmentDate: 'Appointment Date',
        appointmentTime: 'Appointment Time',
        appointmentDuration: 'Appointment Duration',
        ediNumber: 'EDI Number',
        linkedEdiNumber: 'Linked EDI Number',
        orderNumber: 'Order Number',
        orderDate: 'Order date',
        orderStatus: 'Ordre status',
        creditNotes: 'Credit Notes',
        minutes: 'Minutes',
        unconfirmed: 'Unconfirmed',
        warehouse: 'Warehouse',
        availableQty: 'Available',
        nonBatch: 'Non-batch',
        packageTitle: 'Manage Packages',
        pickup: 'Pickup',
        pickupBy: 'Pickup By',
        deliveryDate: 'Delivery Date',
        shippingDate: 'Shipping Date',
        note: 'Note',
        shippingOrder: 'Shipping Order',
        shippingOrderText: 'View',
        referenceNumber: 'Order Reference',
        internalNote: 'Note',
      },
      package: {
        newPackageCardTitle: 'Create package',
        UnassignedProductCardTitle: 'Unassgined Products',
        created: 'Package successfully created',
        error: 'Error creating package',
        addProductToPackageTitle: 'Add products to package',
        editProductToPackageTitle: 'Edit products in the package',
        downloadAllShippingLabel: 'Download shipping label',
        downloadProductMixLabel: 'Download product packaging label',
        viewShippingLabel: 'View shipping label',
        viewProductMixLabel: 'View mixed products label',
        editPackage: 'Edit package',
        deletePackage: 'Delete package',
        addProduct: 'Add product',
        btnAddProduct: 'Add product',
        unassignedTable: {
          name: 'Name',
          gtin: 'GTIN',
          quantityConfirmed: 'Quantity Confirmed',
          quantityPacked: 'Quantity Packed',
          quantityUnpacked: 'Unassigned Quantites',
        },
        createdPackage: {
          sscc: 'SSCC',
          unitType: 'Pallet Type',
          numberOfProducts: 'Number of Products',
          totalQuantity: 'Total Quantity',
          totalNetWeight: 'Total Net Weight',
          totalGrossWeight: 'Total Gross Weight',
          totalStackWeight: 'Total Stack Weight',
          products: 'Products',
          table: {
            gtin: 'GTIN',
            productName: 'Product Name',
            quantity: 'Quantity',
            weight: 'Weight',
            bestBefore: 'Best Before',
            maxTopLoad: 'Max Top Load',
            lotBatchNumber: 'Lot / Batch Number',
            temperatureRequirement: 'Temperature Requirement',
          },
        },
      },
    },

    packageOrderProduct: {
      add: {
        error: 'Error!',
        quantityExceedError:
          'Quantity exceeded. Please check the unpacked quantities.',
        success: 'Successfully added the product to the package.',
      },
      edit: {
        error: 'Error!',
        quantityExceedError:
          'Quantity exceeded. Please check the unpacked quantities.',
        success: 'Successfully updated the product to the package.',
      },
      destroy: {
        confirm: 'Remove order product from the package?',
        error: 'Error!',
        success: 'Successfully removed the product to the package.',
      },
    },

    package: {
      destroy: {
        confirm:
          'All orders inside the package will be unassigned. Boxes inside will be deleted. Delete the package?',
        error: 'Error!',
        success: 'Successfully deleted the package.',
      },
    },

    ediOrders: {
      index: {
        title: 'EDI Orders Overview',
        cardHeader: 'Order # ',
        orderNumber: 'Vinmonopolet order number #',
        ediOrderTypeName: 'Order type #',
        created: 'Created',
        confirmed: 'Confirmed',
        processed: 'processed',
        shipped: 'Shipped',
        picked: 'Picked',
        received: 'received',
        completed: 'completed',
        pending: 'pending',
        out_of_stock: 'Out of Stock',
        invoiced: 'invoice created',
        invoiced_externally: 'Invoiced externally',
        bill_sent: 'invoiced',
        credited: 'credited',
        cancelled: 'cancelled',
        shipping_confirmed: 'Shipping Confirmed',
        invoiced_consolidated: 'Invoiced Consolidated',
        waiting_autobilling: 'Waiting Auto-Billing',
        vipps_processing: 'Vipps Processing',
        confirmAction1: 'Are you sure you want to proceed with',
        confirmAction2: 'on all the',
        confirmAction3: 'selected orders',
        action: {
          confirmOrder: 'Confirm Order',
          confirmShipping: 'Confirm Shipping',
          confirmOrderAndShipping: 'Confirm Order & Shipping',
          createInvoice: 'Create Invoice',
          cancelOrder: 'Cancel Order',
        },
      },
      edit: {
        title: 'EDI Order Information',
        orderNumber: 'Order Number',
        orderReference: 'Order Reference',
        requestedDeliveryDate: 'Requested Delivery Date',
        noEdiOrderItemWarning: 'No item on this order.',
        ediOrderType: 'EDI Order Type',
        partyId: 'Store ID',
        storeName: 'Store Name',
        deliveryDate: 'Delivery Date',
        ediOrderStatus: 'Status',
        invalidDeliveryDate: 'Please, enter a valid delivery date.',
        confirmSuccess: 'Order was confirmed successfully.',
        vippsProcessingTitle: 'Please Wait.',
        vippsProcessing: 'Order is processing Vipps payment, please reload the page after a few minutes.',
        confirmError:
          'There was an error with the order, please try again later.',
        invoiceSuccess: 'Invoice was created successfully.',
        invoiceSentSuccess: 'Invoice was sent successfully.',
        creditNoteSentSuccess: 'Credit note was sent successfully.',
        invoiceError:
          'There was an error with the order, please try again later.',
        processSuccess: 'Order was processed successfully.',
        processError:
          'There was an error with the order, please try again later.',
        pleaseConfirmAllOrders: 'Please confirm all items in this order.',
        cancelSuccess: 'Order was cancelled successfully.',
        returnSuccess: 'Order was successfully returned.',
        confirmCancel: 'Are you sure you want to cancel this order?',
        cancelError:
          'There was an error with the order, please try again later.',
        ediOrderSourceWineMonopolyOrderReference:
          'Source Vinmonopolet Order Reference',
        orderDate: 'Order Date',
        warehouseChanged: 'Warehouse updated',
      },
    },

    settings: {
      generalSettings: 'General Settings',
      productDisplay: 'Product additional info to display',
      newField: 'New Field',
      edi: {
        defaultEdiProductGroupName: 'Default EDI product group name',
        defaultEdiClientGroupName: 'Default EDI client group name',
        defaultEdiClientName: 'Default EDI client name',
        defaultEdiClientContactPhoneNumber: 'Default EDI client phone number',
        defaultEdiClientAddressStreetName: 'Default EDI client street name',
        defaultEdiClientAddressCityId: 'Default EDI client city',
        defaultEdiClientAddressZipCode: 'Default EDI client zip code',
        defaultEdiTaxPercentage: 'Default EDI tax percentage',
        ediOrderNumberDefault: 'Default EDI order number',
        ediOrderDeliveryNoteNumberDefault: 'Default EDI delivery note number',
      },
    },
  },

  layouts: {
    header: {
      individual: 'Personal',
      company: 'Company',
      viewClient: 'View customer',
    },

    sidebar: {
      storeSynced: 'Active Online Store',
      dashboard: 'Dashboard',
      profile: 'Profile',
      account: 'Account',
      address: 'Address',
      contact: 'Contact',
      settings: 'Settings',
      clientGroups: 'Client Groups',
      clients: 'Clients',
      clientGroup: 'Client Group',
      clientAgreements: 'Client Agreements',
      newAgreement: 'New Agreement',
      importAgreement: 'Import Agreement',
      newOrders: 'New',
      today: 'Today',
      upcoming: 'Upcoming',
      members: 'Members',
      pending: 'Pending',
      inTransit: 'In Transit',
      confirmed: 'Confirmed',
      complete: 'Complete',
      recieved: 'Recieved',
      invoiced: 'Invoiced',
      credited: 'Credited',
      cancelled: 'Cancelled',
      outOfStock: 'Out of Stock',
      done: 'Done',
      latest: 'Latest',
      active: 'Active',
      inActive: 'In Active',
      pastMonth: 'Past Month',
      all: 'All',
      productGroups: 'Product Groups',
      production: 'Production',
      products: 'Products',
      services: 'Services',
      wordpress: 'Wordpress',
      /* Edited */
      orders: 'Orders',
      allOrders: 'All Orders',
      booking: 'Booking',
      ediOrders: 'EDI',
      orderFilter: 'Order Status',
      /* Edited */
      logout: 'Logout',
      publicProfile: 'Public',
      appointments: 'Appointments',
      bills: 'Bills',
      edi: 'EDI',
      reports: 'Reports',
      newsletter: 'Newsletter',
      subscriberList: 'Lists',
      // Clients innersidebar
      orderedPastWeek: 'Ordered past week',
      orderedPastMonth: 'Ordered past month',
      neverOrdered: 'Prospects',
      emptyOrders: 'With only empty orders',
      switchToOrganization: 'Change to',
      supplier: 'Suppliers',
      warehouse: 'Warehouses',
      unitOfMeasure: 'Unit of Measures',
      stock: 'Stock',
      inventory: 'Inventory',
      billExport: 'Export',
      modules: 'Modules',
      deactivated: 'Deactivated',
      notInvoiced: 'Not invoiced',
      orderPickups: {
        title: 'Orderplukk',
        viewAll: 'Vis alle',
      },
    },
  },
  pricingAgreements: {
    title: 'Pricing agreements',
    titleWithCount: 'Pricing agreements ({count})',
    newAgreement: 'New agreement',
    createOne: 'Create one',
    importFromTemplate: 'Import from template',
    importFromTemplateLink: 'import from Excel/CSV template',
    noAgreements: 'No pricing agreements.',
    customer: 'Customer',
    selectCustomer: 'Select customer',
    agreementName: 'Agreement name',
    agreementNamePlaceholder: 'Optional; uses template name if empty',
    file: 'File',
    downloadTemplate: 'Download template (XLSX)',
    chooseFile: 'Choose file (CSV or XLSX)',
    cancel: 'Cancel',
    import: 'Import',
    active: 'Active',
    inactive: 'Inactive',
    valid: 'Valid',
    lineCount: '{n} line(s)',
    newPricingAgreement: 'New pricing agreement',
    orImportLink: 'Or',
    name: 'Name',
    namePlaceholder: 'e.g. Seasonal agreement',
    validFrom: 'Valid from',
    validTo: 'Valid to',
    from: 'From',
    to: 'To',
    save: 'Save',
    createButton: 'Create',
    back: 'Back',
    editPricingAgreement: 'Edit pricing agreement',
    product: 'Product',
    products: 'Products',
    addProduct: 'Add product',
    searchProductByName: 'Search product by name',
    minQty: 'Min qty',
    discountLabel: 'Discount',
    discountPercent: 'Discount %',
    discountAmount: 'Discount amount',
    discountAmt: 'Discount amt',
    perUnit: 'Per unit',
    comment: 'Comment',
    noProductsInAgreement: 'No products in this agreement.',
    productFallback: 'Product #',
    confirm: 'Confirm',
    deleteProductConfirm: 'Delete this product from the agreement?',
    agreementUpdated: 'Agreement updated',
    errorUpdatingAgreement: 'Error updating agreement',
    productAndMinQtyRequired: 'Product and Min qty required',
    setDiscountOrAmount: 'Set either Discount % or Discount amount',
    productAdded: 'Product added',
    errorAddingProduct: 'Error adding product',
    minQtyAtLeast1: 'Min qty must be at least 1',
    productUpdated: 'Product updated',
    errorUpdatingProduct: 'Error updating product',
    productRemoved: 'Product removed',
    errorRemovingProduct: 'Error removing product',
    importCreated: 'Agreement created. {count} line(s) added.',
    importSkipped: '{count} row(s) skipped.',
    importFailed: 'Import failed',
    unmatchedTitle: 'Match products (no EPD/GTIN)',
    unmatchedIntro: 'Products with no EPD/GTIN or no discount % appear here. Select product if needed, enter discount %, then click Add.',
    importedName: 'Imported name',
    addLine: 'Add',
    lineAdded: 'Line added',
    closeAndViewAgreement: 'Close and view agreement',
    needToMatch: '{count} product(s) need matching',
    searchProductsInAgreement: 'Search products',
    noProductsMatchSearch: 'No products match your search.',
    searchAgreements: 'Search agreements',
    noAgreementsMatchSearch: 'No agreements match your search or filter.',
    deleteAgreementConfirm: 'Delete this pricing agreement? This cannot be undone.',
    customerHasAgreementConfirm: 'This customer already has a pricing agreement. Do you want to continue importing?',
    agreementDeleted: 'Pricing agreement deleted',
    errorDeletingAgreement: 'Error deleting pricing agreement',
    errorCreatingAgreement: 'Error creating agreement',
    validationNameAlreadyExists: 'This customer already has a pricing agreement with this name.',
    lines: 'Lines',
    actions: 'Actions',
    sortNameAsc: 'Name (A → Z)',
    sortNameDesc: 'Name (Z → A)',
    sortCustomerAsc: 'Customer (A → Z)',
    sortCustomerDesc: 'Customer (Z → A)',
    sortValidFromDesc: 'Valid from (newest)',
    sortValidFromAsc: 'Valid from (oldest)',
    sortProductNameAsc: 'Name (A to Z)',
    sortProductNameDesc: 'Name (Z to A)',
    sortMinQtyAsc: 'Min qty (low to high)',
    sortMinQtyDesc: 'Min qty (high to low)',
  },
  button: {
    search: 'Search',
    createReminder: 'Create Reminder',
    creditNoteReason: 'Set Credit Note Reason',
    glnLookup: 'Fetch Data FROM GLN',
    markAs: 'Mark as',
    pending: 'Pending',
    updateDraft: 'Update draft',
    updatePending: 'Update Pending',
    complete: 'Complete',
    createReturnOrder: 'Create return order',
    addClient: 'Add New Client',
    addClientGroup: 'Add Client Group',
    addBookingOrder: 'Add Booking Order',
    addEdiOrder: 'Add Edi Order',
    addCampaign: 'Add Campaign',
    addSubscriberList: 'Create List',
    enter: 'Enter',
    expand: 'Expand',
    register: 'Register',
    next: 'Next',
    getStarted: 'Get Started',
    done: 'Done',
    save: 'Save',
    update: 'Update',
    view: 'View',
    clear: 'Clear',
    confirm: 'Confirm',
    shippingConfirm: 'Confirm Shipping',
    purcahseReceive: 'Received Purchase',
    process: 'Process',
    proceed: 'Proceed',
    createInvoice: 'Create Invoice',
    invoiceExternally: 'Invoice Externally',
    updateInvoice: 'Update Invoice',
    saveDraft: 'Save as Draft',
    markAsCleared: 'Mark as Cleared',
    createCreditNote: 'Create Credit Note',
    showPrintableDeliveryNote: 'Show Printable Delivery Note',
    downloadPrintableDeliveryNote: 'Download Printable Delivery Note',
    login: 'Login',
    send: 'Send',
    resend: 'Re-send',
    sendTest: 'Send Test',
    cancel: 'Cancel',
    cancelEDIOrder: 'Cancel EDI order',
    cancelOrder: 'Cancel order',
    cancelOrders: 'Cancel Orders',
    delete: 'Delete',
    deleteProduct: 'Delete product',
    deleteClient: 'Delete customer',
    downloadImport: 'Download / Import',
    yes: 'Yes',
    no: 'No',
    skip: 'Skip',
    registerCRM: 'Signup CRM',
    registerInvoicing: 'Signup Invoicing',
    registerBooking: 'Signup Booking',
    registerEDI: 'Signup EDI',
    editText: 'Edit Text',
    testEmail: 'Test',
    testEmailTitle: 'Send a test invoice to your email',
    addMultipleProducts: 'Add Products',
    add: 'Add',
    edit: 'Edit',
    book: 'Book',
    close: 'Close',
    receipt: 'Create Receipt',
    markAsDraft: 'Draft',
    markAsDone: 'Received',
    merge: 'Merge',
    confirmAsOrder: 'Confirmed as Order',
    import: 'Import',
    adjustment: {
      completeAdjustment: 'Complete adjustment',
      exportAdjustmentProducts: 'Download products',
    },
    stockCount: {
      completeStockCount: 'Complete inventory count',
    },
    export: 'Export data',
    dragAndDropImport: 'Drag and drop files here...',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribed',
    syncData: 'Sync Data',
    startSync: 'Start Sync',
    fetchFromVmp: 'Fetch from VMP',
    confirmSync: 'Confirm Sync',
    syncNow: 'Sync Now',
    continue: 'Continue',
    setMinimumStock: 'Set minimum stock',
    destroy: 'destroy',
    unsubscribeAll: 'Unsubscribe all',
    subscribeAll: 'Subscribe all',
    goToEditPage: 'Go to edit page',
    reload: 'Reload',
    bulkPriceUpdate: 'Bulk Price Update',
  },

  search: {
    title: {
      placeholder: 'Search',
    },
  },

  sort: {
    title: 'Sort by',
    placeholder: 'Select',
    older: 'Older',
    newer: 'Newer',
    lastName: 'Last name',
    name: 'Name',
    bestPaying: 'Best paying',
    worstPaying: 'Worst paying',
    biggestDebtors: 'Biggest Debtors',
    clientsCountDesc: 'Most clients',
    clientsCountAsc: 'Least clients',
    lastWeek: 'Last week',
    last14Days: 'Last 14 days',
    last21Days: 'Last 21 days',
    lastMonth: 'Last month',
  },

  listType: {
    all: 'All',
    order: 'Regular Order',
    edi: 'EDI Order',
  },

  orderActions: {
    select: {
      label: 'Select Action',
      placeholder: 'Action',
    },
    confirmOrder: 'Confirm orders',
    confirmShipping: 'Confirm orders shipping',
    confirmOrderAndShipping:
      'Confirm order & shipping (a combination of the first 2 options above)',
    dowloadDeliverySlip: 'Download delivery slips',
    createInvoice: 'Create invoices',
    cancelOrder: 'Cancel orders',
  },

  productActions: {
    select: {
      label: 'Select Action',
      placeholder: 'Action',
    },
    activateProduct: 'Activate Product',
    deactivateProduct: 'Deactivate Product',
    syncToWoo: 'Sync to WP Store',
  },

  clientActions: {
    select: {
      label: 'Select Action',
      placeholder: 'Action',
    },
    isSubClient: 'Is Sub Client',
    isProducer: 'Is Producer',
    activateClient: 'Activate Client',
    deactivateClient: 'Deactivate Client',
  },

  billActions: {
    markBilledAsPaid: 'Mark billed as paid',
    downloadInvoicePdf: 'Download Invoice PDF',
  },

  messages: {
    warning: 'Warning',
    newer: 'Newer',
    lastName: 'Last name',
  },

  form: {
    batch: {
      transferDate: {
        placeholder: '',
        label: 'Date',
      },
      productName: {
        placeholder: '',
        label: 'Products',
      },
      qty: {
        placeholder: '',
        label: 'QTY',
      },
      warehouse: {
        placeholder: '',
        label: 'Warehouse',
      },
    },
    bundleProductPreview: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      price: {
        label: 'Price',
        placeholder: 'Price',
      },
    },
    unimicroCredentialsModal: {
      title: 'UniMicro Credentials',
      intro:
        'Please provide your UniMicro credentials below to connect your accounting integration.',
      unimicro_client_id: {
        label: 'Client ID',
        placeholder: 'Enter your UniMicro Client ID',
      },
      unimicro_client_secret: {
        label: 'Client Secret',
        placeholder: 'Enter your UniMicro Client Secret',
      },
      unimicro_access_token: {
        label: 'Access Token',
        placeholder: 'Paste your UniMicro Access Token',
      },
      unimicro_refresh_token: {
        label: 'Refresh Token',
        placeholder: 'Paste your UniMicro Refresh Token',
      },
    },
    billReminderModal: {
      title: 'Create Reminder',
      reminderType: {
        label: 'Reminder Type',
        placeholder: '',
      },
      feeAmount: {
        label: 'Fee Amount',
        placeholder: '',
      },
      penaltyFee: {
        label: 'Penalty fee',
        placeholder: '',
        options: {
          withFees: 'With Fees',
          withoutFees: 'Without Fees',
        },
      },
      notes: {
        label: 'Notes',
        placeholder: 'Notes',
      },
    },
    license: {
      organizationNumber: {
        label: 'Organization Number',
        placeholder: '',
      },
      licenseTypeId: {
        label: 'License Type',
        placeholder: '',
      },
      licensePermitTypeId: {
        label: 'License Permit Type',
        placeholder: '',
      },
      licenseGroupIds: {
        label: 'License Groups',
        placeholder: '',
      },
      validFrom: {
        label: 'Valid from',
        placeholder: '',
      },
      validTo: {
        label: 'Valid to',
        placeholder: '',
      },
      licenseFile: {
        label: 'License file',
        placeholder: '',
      },
      licenseNumber: {
        label: 'License Number',
        placeholder: '',
      },
      name: {
        label: 'Name',
        placeholder: '',
      },
      streetName: {
        label: 'Street Address',
        placeholder: '',
      },
      postalCode: {
        label: 'Postal Code',
        placeholder: '',
      },
      city: {
        label: 'City',
        placeholder: '',
      },
      municipality: {
        label: 'Municipality',
        placeholder: '',
      },
      municipalityNumber: {
        label: 'Municipality Number',
        placeholder: '',
      },
    },
    bulkSendTurnOver: {
      from: {
        label: 'From',
        placeholder: 'From',
      },
      subject: {
        label: 'Subject',
        placeholder: 'Subject',
      },
      message: {
        label: 'Message',
        placeholder: 'Message',
      },
    },
    wooCredentialsModal: {
      routesTitle: 'Copy and paste below url to woocommerce webhook',
      title: 'Woocommerce api (From kundan system to woocommerce)',
      kundanWordpressPluginToken: 'Kundan Wordpress Plugin Token',
      websiteUrl: {
        placeholder: 'Website url',
        label: 'Website url',
      },
      apiKey: {
        placeholder: 'Api key',
        label: 'Api key',
      },
      secretKey: {
        placeholder: 'Secret key',
        label: 'Secret key',
      },
      language: {
        placeholder: '',
        label: 'Language',
      },
      productAttributes: {
        placeholder: '',
        label: 'Product Attributes',
      },
      syncProductGroup: {
        placeholder: '',
        label: 'Sync Product Type Group/Sub-group',
      },
      syncSelectedProductsOnly: {
        placeholder: '',
        label: 'Sync Selected Products Only',
      },
      warehouseId: {
        placeholder: '',
        label: 'Warehouse Id',
      },
      secret: {
        title: 'Woocommerce secret keys (From woocommerce to kundan system)',
        apiOrderCreated: {
          placeholder: 'Order Secret key (created)',
          label: 'Order Secret key (created)',
        },
        apiOrderUpdated: {
          placeholder: 'Order Secret key (updated)',
          label: 'Order Secret key (updated)',
        },
        apiOrderDeleted: {
          placeholder: 'Order Secret key (deleted)',
          label: 'Order Secret key (deleted)',
        },
        apiCustomerCreated: {
          placeholder: 'Customer Secret key (created)',
          label: 'Customer Secret key (created)',
        },
        apiCustomerUpdated: {
          placeholder: 'Customer Secret key (updated)',
          label: 'Customer Secret key (updated)',
        },
        apiCustomerDeleted: {
          placeholder: 'Customer Secret key (deleted)',
          label: 'Customer Secret key (deleted)',
        },
        apiProductCreated: {
          placeholder: 'Product Secret key (created)',
          label: 'Product Secret key (created)',
        },
        apiProductUpdated: {
          placeholder: 'Product Secret key (updated)',
          label: 'Product Secret key (updated)',
        },
        apiProductDeleted: {
          placeholder: 'Product Secret key (deleted)',
          label: 'Product Secret key (deleted)',
        },
      },
    },
    wordpressCredentialsModal: {
      title: 'Wordpress api',
      kundanWordpressPluginToken: 'Kundan Wordpress Plugin Token',
      websiteUrl: {
        placeholder: 'Website url',
        label: 'Website url',
      },
    },
    orderInternalNote: {
      internalNote: {
        placeholder: 'Internal note',
        label: 'Internal note',
      },
    },
    orderWarehouse: {
      warehouseId: {
        placeholder: 'Select Warehouse',
        label: 'Warehouse',
      },
    },
    module: {
      fiken_email: {
        placeholder: 'Enter Email',
        label: 'Email',
      },
      fiken_password: {
        placeholder: 'Enter password',
        label: 'Password',
      },
      poweroffice_client_key: {
        placeholder: 'Enter Client Key',
        label: 'Client key',
      },
      poweroffice_company_slug: {
        placeholder: 'Enter Company Slug',
        label: 'Company slug',
      },

      poweroffice_app_key: {
        placeholder: 'Enter App Key',
        label: 'App key',
      },
      poweroffice_integration_type: {
        label: 'Integration Type',
        placeholder: 'Select Integration Type',
      },
      tripletex_consumer_token: {
        placeholder: 'Enter Consumer Token',
        label: 'Consumer Token',
      },
      tripletex_employee_token: {
        placeholder: 'Enter Employee Token',
        label: 'Employee Token',
      },
      preferred_invoice_sender: {
        placeholder: 'Select Preferred Invoice Sender',
        label: 'Send Invoice From',
      },
      preferred_send_type: {
        placeholder: 'Select Preferred Send Type',
        label: 'Send Type',
      },
      vmp_wholesaler_id: {
        placeholder: 'Enter Wholesaler ID',
        label: 'Enter Wholesaler ID',
      },
      public_marketplace: {
        placeholder: 'Activate',
        label: 'Public marketplace',
      },
      marketplaces_enabled: {
        placeholder: '',
        label: 'Partnerstore',
      },
      ongoing_warehouse_warehouse: {
        placeholder: '',
        label: 'Ongoing warehouse ID',
      },
      ongoing_warehouse_username: {
        placeholder: '',
        label: 'Ongoing username',
      },
      ongoing_warehouse_password: {
        placeholder: '',
        label: 'Ongoing password',
      },
      ongoing_warehouse_goods_owner_id: {
        placeholder: '',
        label: 'Ongoing Goods Owner ID',
      },
    },
    multipleProductAdd: {
      product: {
        placeholder: 'Type to start searching...',
        label: '',
      },
    },
    exciseEntry: {
      product: {
        placeholder: 'Product select',
        label: '',
      },
      source: {
        placeholder: 'Source select',
        label: '',
      },
    },
    shippingConfirm: {
      shippingProviderId: {
        placeholder: 'Shipping Provider',
        label: 'Shipping Provider',
      },
      shippingDate: {
        placeholder: 'Shipping Date',
        label: 'Shipping Date',
      },
      importantReminder: {
        placeholder: 'Important Reminder',
        label: 'Important Reminder',
      },
    },
    orderConfirm: {
      confirmDate: {
        placeholder: 'Date Confirmed',
        label: 'Date Confirmed',
      },
      deliveryDate: {
        placeholder: 'Delivery Date',
        label: 'Delivery Date',
      },
      warehouseId: {
        placeholder: 'Select warehouse',
        label: 'Warehouse',
      },
    },
    billConfirm: {
      paymentDateOption: {
        placeholder: 'Select Payment Date Option',
        label: 'Payment Date Option',
      },
      paymentDate: {
        placeholder: 'Payment Date',
        label: 'Payment Date',
      },
      paymentMethod: {
        label: 'Payment methods',
        placeholder: 'Payment methods',
      },
    },
    purchaseReceive: {
      receiveDate: {
        placeholder: 'Date Received',
        label: 'Date Received',
      },
    },
    registerBillPayment: {
      paymentDate: {
        placeholder: 'Payment date',
        label: 'Payment date',
      },
      paymentInFull: {
        placeholder: 'Yes',
        label: 'Payment in full?',
      },
      paymentAmount: {
        placeholder: 'Payment amount',
        label: 'Payment amount',
      },
    },
    registerCreditNoteReason: {
      creditNoteReasonId: {
        label: 'Reason for crediting',
        placeholder: 'Select a reason',
      },
      reasonNote: {
        label: 'Actions',
        placeholder: 'Actions',
      },
      additionalDescription: {
        label: 'Additional info',
        placeholder: 'Enter any additional info (not required)',
      },
      systemAttributes: {
        label: '',
        placeholder: '',
      },
    },
    billPaymentModal: {
      title: 'Bill payment',
      amountDue: 'Amount due on the',
      isFullyPaid: {
        label: 'Fully paid',
        placeholder: 'Fully paid',
      },
      paymentMethod: {
        label: 'Payment method',
        placeholder: 'payment method',
      },
      amountPaid: {
        label: 'Amount paid',
        placeholder: 'Amount paid',
      },
      paymentDate: {
        label: 'Payment date',
        placeholder: 'Payment date',
      },
      reference: {
        label: 'Reference',
        placeholder: 'Reference',
      },
      internalNote: {
        label: 'Internal note',
        placeholder: 'Internal note',
      },
    },
    supplier: {
      basicInformation: 'Basic Information',
      contactInformation: 'Contact Information',
      AddressInformation: 'Address Information',
      code: {
        placeholder: 'Code',
        label: 'Supplier code',
      },
      name: {
        placeholder: 'Name',
        label: 'Supplier Name',
      },
      email: {
        placeholder: 'Email',
        label: 'Supplier Email',
      },
      phonenumber: {
        placeholder: 'Phone Number',
        label: 'Supplier phone number',
      },
      mobilenumber: {
        placeholder: 'Mobile Number',
        label: 'Supplier mobile number',
      },
      streetName1: {
        placeholder: 'Street Name',
        label: 'Supplier street name',
      },
      streetName2: {
        placeholder: 'Street Name 2',
        label: 'Supplier street name 2',
      },
      city: {
        placeholder: 'City',
        label: 'Supplier city',
      },
      countryId: {
        placeholder: 'Country',
        label: 'Supplier country',
      },
      postalCode: {
        placeholder: 'Postal Code',
        label: 'Supplier postal code',
      },
    },

    warehouse: {
      basicInformation: 'Basic Information',
      contactInformation: 'Contact',
      addressInformation: 'Address',
      warehouseInformation: 'Warehouse',
      location: {
        placeholder: 'Location',
        label: 'Warehouse location',
      },
      name: {
        placeholder: 'Name',
        label: 'Warehouse Name',
      },
      isActive: {
        placeholder: '',
        label: 'Active',
      },
      typeName: {
        placeholder: 'Type',
        label: 'Warehouse Type',
      },
      partnerId: {
        placeholder: 'Owner',
        label: 'Owner',
      },
      isBonded: {
        label: 'Bonded warehouse',
        placeholder: '',
      },
      shippingProviders: {
        label: 'Warehouse providers',
        placeholder: '',
      },
      contact: {
        firstName: {
          label: 'First name',
          placeholder: '',
        },
        lastName: {
          label: 'Last name',
          placeholder: '',
        },
        email: {
          label: 'Email address',
          placeholder: '',
        },
        phoneNumber: {
          label: 'Phone number',
          placeholder: '',
        },
      },
      address: {
        streetName1: {
          label: 'Street name',
          placeholder: '',
        },
        streetName2: {
          label: 'Street name 2',
          placeholder: '',
        },
        postalCode: {
          label: 'Postal code',
          placeholder: '',
        },
        city: {
          label: 'City',
          placeholder: '',
        },
        countryId: {
          label: 'Country',
          placeholder: '',
        },
      },
      productTab: {
        modal: {
          title: 'Stock management',
          minimumStockLevel: {
            label: 'Minimum stock level',
            placeholder: 'Minimum stock level',
          },
        },
      },
    },

    productFlow: {
      basicInformation: 'Basic Information',
      title: {
        placeholder: 'Title',
        label: 'Title',
      },
      descriptions: {
        placeholder: 'Descriptions',
        label: 'Descriptions',
      },
      orderId: {
        placeholder: 'Order',
        label: 'Order',
      },
      productId: {
        placeholder: 'Product',
        label: 'Product',
      },
      qty: {
        placeholder: 'Return/Damage',
        label: 'Return/Damage',
      },
    },

    unitOfMeasure: {
      basicInformation: 'Basic Information',
      code: {
        placeholder: 'Code',
        label: 'Unit of Measure Code',
      },
      name: {
        placeholder: 'Name',
        label: 'Unit of Measure Name',
      },
    },

    stock: {
      basicInformation: 'Basic Information',
      warehouseId: {
        placeholder: 'Warehouse',
        label: 'Warehouse',
      },
      name: {
        placeholder: 'Name of stock count',
        label: 'Name of stock count',
      },
      descriptions: {
        placeholder: 'Enter Description',
        label: 'Description',
      },
      transactionDate: {
        placeholder: '',
        label: 'Transaction Date',
      },
    },

    adjustment: {
      basicInformation: 'Basic Information',
      stockId: {
        placeholder: 'Stock',
        label: 'Stock',
      },
      reason: {
        placeholder: 'Reason',
        label: 'Reason',
      },
      warehouseId: {
        placeholder: 'Warehouse',
        label: 'Warehouse',
      },
      adjustmentTypeId: {
        placeholder: 'Adjustment type',
        label: 'Adjustment type',
      },
      adjustmentTypeList: {
        adjustment: 'Adjustment',
        wastage: 'Wastage',
        destruction: 'Destruction',
      },
      adjustmentStatus: {
        completed: 'Completed',
        draft: 'Draft',
        pending: 'Pending',
        sent: 'Sent',
        cancelled: 'Cancelled',
        deviation: 'Deviation',
      },
    },

    purchase: {
      basicInformation: 'Basic Information',
      producerId: {
        placeholder: 'Producer',
        label: 'Producer',
      },
      supplierId: {
        placeholder: 'Supplier',
        label: 'Supplier',
      },
      comments: {
        placeholder: 'Comments',
        label: 'Comments',
      },
      name: {
        placeholder: 'Name',
        label: 'Name',
      },
      purchaseNumber: {
        placeholder: 'PO #',
        label: 'PO #',
      },
      warehouseId: {
        placeholder: 'Warehouse',
        label: 'Warehouse',
      },
      status: {
        placeholder: 'Status',
        label: 'Status',
      },
      expectedDeliveryDate: {
        placeholder: 'Pick date',
        label: 'Expected deliverydate',
      },
    },

    transfer: {
      basicInformation: 'Transferdetails',
      date: {
        placeholder: 'Transfer Date',
        label: 'Transfer Date',
      },
      transferType: {
        placeholder: 'Transfer Type',
        label: 'Transfer Type',
      },
      fromWarehouseId: {
        placeholder: 'From Warehouse',
        label: 'From Warehouse',
      },
      toWarehouseId: {
        placeholder: 'To Warehouse',
        label: 'To Warehouse',
      },
      batchId: {
        placeholder: 'Select Batch',
        label: 'Batch',
      },
      comments: {
        placeholder: 'Comments',
        label: 'Comments',
      },
      products: {
        placeholder: 'Pick a Products',
        label: 'Products',
      },
      batches: {
        placeholder: 'Pick a Batches',
        label: 'Batches',
      },
      productId: {
        label: 'Product Name',
        placeholder: 'Select product',
      },
      qty: {
        label: 'QTY',
        placeholder: 'QTY',
      },
    },

    register: {
      organizationType: {
        label: 'This is account is for:',
        personal: 'Personal Use',
        company: 'Company Use',
      },
      businessRegistrationNumber: {
        placeholder: 'Business Registration Number',
      },
      firstName: {
        placeholder: 'First Name',
      },
      lastName: {
        placeholder: 'Last Name',
      },
      name: {
        placeholder: 'Business Name',
      },
      email: {
        placeholder: 'Email',
      },
      password: {
        placeholder: 'Password',
      },
      passwordConfirmation: {
        placeholder: 'Retype Password',
      },
      planId: {
        placeholder: 'Plan',
      },
      organizationTypeId: {
        placeholder: 'Organization Type',
      },
      organizationTypeOption: {
        placeholder: 'I am singing up for a company',
      },
      isVatRegistered: {
        placeholder: 'VAT registered',
      },
      isRegisteredBusinessEnterprise: {
        placeholder: 'Registered as business enterprise',
      },
      tosAccepted: {
        placeholder:
          'I agree to the <a href="http://www.kundan.no/regler/">Terms of Service</a>',
      },
      marketingAllowed: {
        placeholder:
          'I would like to receive info and marketing offers by Kundan!',
      },
    },

    personalInfo: {
      phoneNumber: {
        placeholder: 'Phone Number',
      },
      streetName: {
        placeholder: 'Street Name',
      },
      secondStreetName: {
        placeholder: 'Street Name 2',
      },
      postalCode: {
        placeholder: 'Postal Code',
      },
      countryId: {
        placeholder: 'Select a Country',
      },
      cityName: {
        placeholder: 'City',
      },
    },

    login: {
      email: {
        placeholder: 'Email',
      },
      password: {
        placeholder: 'Password',
      },
    },

    resetPassword: {
      email: {
        placeholder: 'Type your email',
      },
    },

    twoFactorVerification: {
      code: {
        label: 'Enter Code',
        placeholder: 'Enter Code',
      },
      verifyButton: {
        label: 'Verify',
      },
      resendButton: {
        label: 'Resend',
      },
    },

    accountInformation: {
      email: {
        label: 'Email',
        placeholder: 'Email',
      },
      firstName: {
        label: 'First Name',
        placeholder: 'First Name',
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Last Name',
      },
      userEmail: {
        label: 'Email',
        placeholder: 'Email',
      },
      userFirstName: {
        label: 'First Name',
        placeholder: 'First Name',
      },
      userLastName: {
        label: 'Last Name',
        placeholder: 'Last Name',
      },
      bankAccount: {
        label: 'Bank Account',
        placeholder: 'Bank Account',
      },
      smallScaleManufacturer: {
        label: 'Yearly production above 500.000 liter',
        placeholder: 'Activate',
      },
      businessRegistrationNumber: {
        label: 'Business Registration Number',
        placeholder: 'Business Registration Number',
      },
      isInternational: {
        label: 'International',
        placeholder: 'Activate',
      },
      bankName: {
        label: 'Bank Name',
        placeholder: 'Bank Name',
      },
      swift: {
        label: 'Swift/Bic',
        placeholder: 'Swift/Bic',
      },
      iban: {
        label: 'IBAN',
        placeholder: 'IBAN',
      },
      isVatRegistered: {
        label: 'VAT Registered',
        placeholder: 'Activate',
      },
      isRegisteredBusinessEnterprise: {
        label: 'Registered Business Enterprise',
        placeholder: 'Activate',
      },
      organizationTypeId: {
        label: 'Select a Organization Type',
        placeholder: 'Organization Type',
      },
      organizationName: {
        label: 'Business Name',
        placeholder: 'Business Name',
      },
      name: {
        label: 'Organization Name',
        placeholder: 'Organization Name',
      },
      organizationDescription: {
        label: 'Business Description',
        placeholder: 'Business Description',
      },
      description: {
        label: 'Organization Description',
        placeholder: 'Organization Description',
      },
      organizationProfilePicture: {
        label: 'Organization Profile Picture',
        placeholder: 'Organization Profile Picture',
        changeImage: 'Change image',
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Phone Number',
      },
      mobileNumber: {
        label: 'Mobile Number',
        placeholder: 'Mobile Number',
      },
      profilePicture: {
        label: 'Organization Profile Picture',
        placeholder: 'Organization Profile Picture',
      },
      streetName: {
        label: 'Street Name',
        placeholder: 'Street Name',
      },
      gs1number: {
        label: 'GS1 supplier number',
        placeholder: 'GS1 supplier number',
      },
    },

    passwordForm: {
      currentPassword: {
        label: 'Current Password',
        placeholder: 'Current Password',
      },
      password: {
        label: 'Password',
        placeholder: 'Password',
      },
      passwordConfirmation: {
        label: 'Retype Password',
        placeholder: 'Retype Password',
      },
    },

    contactForm: {
      email: {
        label: 'Email',
        placeholder: 'Email',
      },
      firstName: {
        label: 'First Name',
        placeholder: 'First Name',
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Last Name',
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Phone Number',
      },
      mobileNumber: {
        label: 'Mobile Number',
        placeholder: 'Mobile Number',
      },
      streetName: {
        label: 'Street Name',
        placeholder: 'Street Name',
      },
      secondStreetName: {
        label: 'Street Name 2',
        placeholder: 'Street Name 2',
      },
      postalCode: {
        label: 'Postal Code',
        placeholder: 'Postal Code',
      },
      countryId: {
        label: 'Country',
        placeholder: 'Country',
      },
      cityName: {
        label: 'City',
        placeholder: 'City',
      },
      careOf: {
        label: 'C/O',
        placeholder: 'C/O',
      },
    },

    userSettingForm: {
      language: {
        label: 'Language',
        placeholder: 'Select Language',
      },
    },

    profileAddress: {
      streetName: {
        label: 'Street Name',
        placeholder: 'Street Name',
      },
      secondStreetName: {
        label: 'Street Name 2',
        placeholder: 'Street Name 2',
      },
      postalCode: {
        label: 'Postal Code',
        placeholder: 'Postal Code',
      },
      countryId: {
        label: 'Select a Country',
        placeholder: 'Select a Country',
      },
      cityName: {
        label: 'City',
        placeholder: 'City',
      },
    },

    profileContact: {
      email: {
        label: 'Email',
        placeholder: 'Email',
      },
      firstName: {
        label: 'First Name',
        placeholder: 'First Name',
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Last Name',
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Phone Number',
      },
      mobileNumber: {
        label: 'Mobile Number',
        placeholder: 'Mobile Number',
      },
    },

    organizationSettings: {
      penaltyTypeForDueInvoice: {
        label: 'Reminder Type for Due Invoice',
        placeholder: 'Reminder Type for Due Invoice',
      },
      penaltyFee: {
        label: 'Penalty fee',
        placeholder: 'Penalty fee',
      },
      interestPercentage: {
        label: 'Interest percentage',
        placeholder: 'Interest percentage',
      },
      penaltyAfter: {
        label: 'After dueDate start penalty in (days)',
        placeholder: 'No. of days',
      },
      tosAccepted: {
        label: 'Accepting terms of service',
        placeholder:
          'I accept the following terms of service: http://www.kundan.no/regler/',
      },
      marketingAllowed: {
        label: 'Marketing offers',
        placeholder:
          'I agreee to receive offers and information via email from Kundan AS.',
      },
      customTos: {
        label: 'Custom TOS',
        placeholder:
          'Here you can specify your own TOS for your own products and services.',
      },
      customOrderProductNote: {
        label: 'Custom Order Product Note',
        placeholder: 'Here you can specify your own order product note',
      },
      facebookPixelId: {
        label: 'Facebook Pixel ID',
        placeholder: 'Facebook Pixel ID',
      },
      defaultClientGroupId: {
        label: 'Default Client Group',
        placeholder: 'Select the default client group',
      },
      defaultDueDays: {
        label: 'Default Due Days',
        placeholder: 'Default Due Days',
      },
      orderNumberDefault: {
        label: 'Order Number Default',
        placeholder: 'Order Number Default',
      },
      productNumberDefault: {
        label: 'Product Number Default',
        placeholder: 'Product Number Default',
      },
      productNumberInitial: {
        label: 'Product Number Initial',
        placeholder: 'Product Number Initial',
      },
      defaultProductTypeName: {
        label: 'Product Type Default',
        placeholder: 'Product Type Default',
      },
      customerNumberDefault: {
        label: 'Customer Number Default',
        placeholder: 'Customer Number Default',
      },
      supplierNumberDefault: {
        label: 'Supplier Number Default',
        placeholder: 'Supplier Number Default',
      },
      timeslotGap: {
        label: 'Gap in timeslots',
        placeholder: 'Gap in timeslots',
      },
      invoiceNotes: {
        label: 'Invoice Notes',
        placeholder: 'Notes to be displayed in the invoice.',
      },
      billNotes: {
        label: 'Bill Notes',
        placeholder: 'Notes to be displayed in the bill PDF.',
      },
      creditNoteNotes: {
        label: 'Credit Note Notes',
        placeholder: 'Notes to be displayed in the credit note.',
      },
      billingNumberDefault: {
        label: 'Billing Number Default',
        placeholder: 'Billing Number Default',
      },
      remindersEnabled: {
        label: 'Enable reminders',
        placeholder: 'Enable reminders',
      },
      messageTemplateTypeId: {
        label: 'Message Template Types',
        placeholder: 'Select the type',
      },
      smsFrom: {
        label: 'SMS from field',
        placeholder: 'SMS from field',
      },
      roundInvoiceTotal: {
        label: 'Round Invoice Total',
        placeholder: 'Round Invoice Total',
      },
      invoiceEmailTitle: {
        label: 'Invoice email template title',
        placeholder: 'Invoice email template title',
        tooltip:
          'Variables available:<br/><br/>Company Name: {customer_name} <br/> Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Bill number: {bill_number}<br/><br/>The following are available for bookings:<br/><br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      invoiceEmailTemplate: {
        label: 'Invoice email template',
        placeholder: 'Invoice email template',
        tooltip:
          'Variables available:<br/><br/>Company Name: {customer_name} <br/> Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Bill number: {bill_number}<br/>Invoice/Credit Note link: {link}<br/><br/>The following are available for bookings:<br/><br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      creditNoteEmailTitle: {
        label: 'Credit Note email template title',
        placeholder: 'Credit Note email template title',
      },
      creditNoteEmailTemplate: {
        label: 'Credit Note email template',
        placeholder: 'Credit Note email template',
      },
      reminderEmailTitle: {
        label: 'Payment reminder email template title',
        placeholder: 'Payment reminder email template title',
        tooltip:
          'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Bill number: {bill_number}<br/>Invoice link: {link}<br/>Organization Name: {organization_name}<br/>Organization Contact Name: {organization_contact_name}<br/>Due Date: {due_date}',
      },
      reminderEmailTemplate: {
        label: 'Payment reminder email template',
        placeholder: 'Payment reminder email template',
        tooltip:
        'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Bill number: {bill_number}<br/>Invoice link: {link}<br/>Organization Name: {organization_name}<br/>Organization Contact Name: {organization_contact_name}<br/>Due Date: {due_date}',
      },
      orderConfirmNotificationEmailTitle: {
        label: 'Order confirm notification email template title',
        placeholder: 'Order confirm notification email template title',
        tooltip:
        'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Organization Name: {organization_name}',
      },
      orderConfirmNotificationEmailTemplate: {
        label: 'Order confirm notification email template',
        placeholder: 'Order confirm notification email template',
        tooltip:
        'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Organization Name: {organization_name}',
      },
      orderTrackingEmailTitle: {
        label: 'Order tracking email template title',
        placeholder: 'Order tracking email email template title',
        tooltip:
        'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Order tracking number: {order_tracking_number}<br/>Order tracking link: {tracking}<br/>Organization Name: {organization_name}',
      },
      orderTrackingEmailTemplate: {
        label: 'Order tracking email template',
        placeholder: 'Order tracking email email template',
        tooltip:
        'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Order tracking number: {order_tracking_number}<br/>Order tracking link: {tracking}<br/>Organization Name: {organization_name}',
      },
      accountingProviderId: {
        label: 'Select accounting provider',
        placeholder: 'Select the accounting provider',
      },
      coa1460: {
        label: 'Purchased goods for resale',
        placeholder: '',
      },
      coa1500: {
        label: 'Accounts receivable',
        placeholder: '',
      },
      coa1610: {
        label: 'VAT from purchases',
        placeholder: '',
      },
      coa1910: {
        label: 'Petty cash',
        placeholder: '',
      },
      coa1920: {
        label: 'Cash in bank',
        placeholder: '',
      },
      coa2400: {
        label: 'Trade Creditors',
        placeholder: '',
      },
      coa2700: {
        label: 'VAT from sales',
        placeholder: '',
      },
      coa3010: {
        label: 'Revenue from products',
        placeholder: '',
      },
      coa3020: {
        label: 'Revenue from services',
        placeholder: '',
      },
      coa3060: {
        label: 'Return of products',
        placeholder: '',
      },
      coa3080: {
        label: 'Discounts provided',
        placeholder: '',
      },
      descriptionBill: {
        label: 'Description',
        placeholder: 'your description',
      },
      ediBillingProcess: {
        label: 'EDI Billing Process',
        placeholder: 'EDI Billing Process',
      },
      paymentIdentitificationGeneration: {
        label: 'Generate payment identification',
        placeholder: '',
      },
      paymentIdentitificationTemplate: {
        label: 'Template',
        placeholder: '',
      },
      paymentIdentitificationNumberLength: {
        label: 'Length of payment number',
        placeholder: '',
      },
      paymentIdentitificationModulusType: {
        label: 'Modulus type',
        placeholder: '',
      },
      defaultShippingProvider: {
        label: 'Default Shipping Provider',
        placeholder: '',
      },
      defaultWarehouse: {
        label: 'Default Warehouse',
        placeholder: '',
      },
      priceFields: {
        label: 'Price Fields',
        placeholder: '',
      },
      visiblePriceFields: {
        label: 'Visible Price Fields',
        placeholder: '',
      },
      defaultPriceField: {
        label: 'Default Price Field',
        placeholder: '',
      },
      email_invoice_copy: {
        label: 'Email',
        placeholder: 'Email',
      },
      percentage: {
        label: 'Percentage (%)',
        placeholder: 'Percentage (%)',
      },
      enableRounding: {
        label: 'Enable Rounding',
        placeholder: 'Enable Rounding',
      },
      roundingType: {
        label: 'Rounding Type',
        placeholder: 'Rounding Type',
        options: {
          nearest_1: 'Nearest 1',
          nearest_0_50: 'Nearest 0.50',
          nearest_0_25: 'Nearest 0.25',
          nearest_0_99: 'Nearest 0.99',
          round_half_up: 'Round Half Up',
          round_half_down: 'Round Half Down',
          round_half_even: 'Round Half Even (Banker\'s Rounding)',
          round_towards_zero: 'Round Towards Zero',
          round_away_from_zero: 'Round Away From Zero',
        },
      },
      priceType: {
        label: 'Price Type',
        placeholder: 'Price Type',
      },
    },

    emailFormSettings: {
      emails: {
        label: 'Emails',
        placeholder: 'Emails',
      },
    },

    checkout: {
      bookingRequireAddress: {
        label: 'Address required',
        placeholder: 'Yes',
      },
      bookingRequirePayment: {
        label: 'Payment required',
        placeholder: 'Yes',
      },
    },

    publicProfile: {
      profileUrl: {
        label: 'Profile URL',
        placeholder: 'Profile URL',
      },
      header: {
        label: 'Header',
        placeholder: 'Header',
      },
      subheader: {
        label: 'Sub Header',
        placeholder: 'Sub Header',
      },
      defaultReminderTitle: {
        label: 'Default reminder title',
        placeholder: 'Default reminder title',
        tooltip:
          'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      defaultReminder: {
        label: 'Default reminder message',
        placeholder: 'Default reminder message',
        tooltip:
          'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      defaultCancelMessageTitle: {
        label: 'Default cancel message title',
        placeholder: 'Default cancel message title',
        tooltip:
          'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      defaultCancelMessage: {
        label: 'Default cancel message',
        placeholder: 'Default cancel message',
        tooltip:
          'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      appointmentConfirmationTitle: {
        label: 'Default confirmation message title',
        placeholder: 'Default confirmation message title',
        tooltip:
          'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      appointmentConfirmationTemplate: {
        label: 'Default confirmation message',
        placeholder: 'Default confirmation message',
        tooltip:
          'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}',
      },
      backgroundImage: {
        label: 'Background Image',
        placeholder: 'Background Image',
        changeImage: 'Change Image',
      },
    },

    clientGroups: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
      priceFieldId: {
        label: 'Pricefield',
        placeholder: 'Pricefield',
      },
      receivables_account_id: {
        label: 'Receivables account',
        placeholder: 'Receivables account',
        help: 'Used for accounting exports when a client in this group has no receivables account set.',
      },
    },

    clients: {
      basicInformation: 'Basic Information',
      otherInformation: 'Other Information',
      contacts: 'Contacts',
      addresses: 'Addresses',
      licenses: 'Licenses',
      postalAddressError: 'Postal address details are required.',
      primaryContactError: 'Primary contact details are required.',
      addContact: 'Add Contact',
      noContactWarning: 'No contacts yet.',
      isSubClient: {
        label: 'Is sub client?',
        placeholder: '',
      },
      projectId: {
        label: 'Project',
        placeholder: '',
      },
      billMainParent: {
        label: 'Bill main Parent',
        placeholder: '',
      },
      dueDays: {
        label: 'Due days',
        placeholder: 'Due days',
      },
      startBilling: {
        label: 'Start billing',
        placeholder: 'Start billing',
      },
      billingInterval: {
        label: 'Billing interval',
        placeholder: 'Billing interval',
      },
      automaticBilling: {
        label: 'Automatic billing',
        placeholder: 'Automatic billing',
      },
      billingType: {
        label: 'Billing type',
        placeholder: 'Billing type',
      },
      externalCustomerNumber: {
        label: 'External customer #',
        placeholder: '',
      },
      orderReference: {
        label: 'Order Reference',
        placeholder: '',
      },
      orderNote: {
        label: 'Order Note',
        placeholder: '',
      },
      priceFieldId: {
        label: 'Price field',
        placeholder: 'Price field',
      },
      receivables_account_id: {
        label: 'Receivables Account',
        placeholder: 'Receivables Account',
        help: 'If empty, the client group receivables account (if set) is used before the organization default.',
      },
      pricePercentageDiscount: {
        label: 'Price discount',
        placeholder: 'Price discount',
      },
      languageId: {
        label: 'Language',
        placeholder: 'language',
      },
      currencyId: {
        label: 'Currency',
        placeholder: 'Currency',
      },
      typeId: {
        label: 'Type',
        placeholder: 'Type',
      },
      fullName: {
        label: 'Full Name',
        placeholder: 'First Name',
      },
      clientGroupId: {
        label: 'Select a Client Group',
        placeholder: 'Client Groups',
      },
      firstName: {
        label: 'First Name',
        placeholder: 'First Name',
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Last Name',
      },
      clientParent: {
        label: 'Client parent',
        placeholder: 'Client parent',
      },
      companyName: {
        label: 'Company Name',
        placeholder: 'Company Name',
      },
      clientType: {
        label: 'Client Type',
        placeholder: 'Client Type',
      },
      contactType: {
        label: 'Contact Type',
        placeholder: 'Contact Type',
      },
      email: {
        label: 'Email',
        placeholder: 'Email',
      },
      invoiceSendMethod: {
        label: 'Invoice Send Method',
        placeholder: 'Preferred Invoice Send Method',
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Phone Number',
      },
      mobileNumber: {
        label: 'Mobile Number',
        placeholder: 'Mobile Number',
        tooltip:
          'The mobile number should be in the format 4xx xx xxx or 9xx xx xxx.',
      },
      careOf: {
        label: 'C/O:',
        placeholder: 'C/O',
      },
      streetName: {
        label: 'Street Name',
        placeholder: 'Street Name',
      },
      secondStreetName: {
        label: 'Street Name 2',
        placeholder: 'Street Name 2',
      },
      postalCode: {
        label: 'Postal Code',
        placeholder: 'Postal Code',
      },
      countryId: {
        label: 'Select a Country',
        placeholder: 'Select a Country',
      },
      cityId: {
        label: 'City',
        placeholder: 'City',
      },
      cityName: {
        label: 'City',
        placeholder: 'City',
      },
      picture: {
        label: 'Picture',
        placeholder: 'Drop file here or click to upload',
        changeImage: 'Change Image',
      },
      organizationNumber: {
        label: 'Organization Number',
        placeholder: 'Enter Organization number',
      },
      isProducer: {
        label: 'Is producer',
        placeholder: 'Active',
      },
      isSupplier: {
        placeholder: 'Active',
        label: 'Is supplier',
      },
      isActive: {
        label: 'Is active',
        placeholder: 'Active',
      },
      manualProcessOrder: {
        label: 'Manual Process Order',
        placeholder: 'Enabled',
      },
      gln: {
        label: 'GLN number',
        placeholder: 'GLN number',
      },
      glnXKoord: {
        label: 'GLN x-coordinates',
        placeholder: 'GLN x-coordinates',
      },
      glnYKoord: {
        label: 'GLN y-coordinates',
        placeholder: 'GLN y-coordinates',
      },
      syncToWoo: {
        label: 'Sync To WP Store',
        placeholder: '',
      },
    },

    catalogues: {
      actionCode: {
        label: 'Action code',
        placeholder: 'Action code',
      },
      productGroupId: {
        label: 'Product Group',
        placeholder: 'Product Group',
      },
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      issuedAt: {
        label: 'Issued At',
        placeholder: 'Issued At',
      },
      versionId: {
        label: 'Version',
        placeholder: 'Version',
      },
      validFrom: {
        label: 'Valid From',
        placeholder: 'Valid From',
      },
      validTo: {
        label: 'Valid To',
        placeholder: 'Valid To',
      },
      reference: {
        label: 'Reference',
        placeholder: 'Reference',
      },
      note: {
        label: 'Internal note',
        placeholder: 'Internal note',
      },
    },

    producers: {
      typeId: {
        label: 'Type',
        placeholder: 'Type',
      },
      name: {
        label: 'Company Name',
        placeholder: 'Enter Company Name',
      },
    },

    billingTypes: {
      options: {
        single: 'Single',
        consolidate: 'Consolidate',
      },
    },

    automaticBilling: {
      options: {
        none: 'None',
        weekly: 'Weekly',
        monthly: 'Monthly',
      },
    },

    billingInterval: {
      week: {
        options: {
          week1: '1 week',
          week2: '2 weeks',
          week3: '3 weeks',
        },
      },
      month: {
        options: {
          month1: '1 month',
          month2: '2 months',
          month3: '3 months',
          month4: '4 months',
          month5: '5 months',
          month6: '6 months',
        },
      },
    },

    startBilling: {
      week: {
        options: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
        },
      },
      month: {
        options: {
          day: 'Day',
        },
      },
    },

    addressTypes: {
      updateActions: 'Update Actions',
      options: {
        postal: 'Postal',
        physicalAddress: 'Physical Address',
        deliveryAddress: 'Delivery Address',
      },
    },

    contactTypes: {
      options: {
        primary: 'Primary',
        accounting: 'Accounting',
      },
    },

    productGroups: {
      parentGroupId: {
        label: 'Parent group',
        placeholder: 'Select parent group',
      },
      exciseGroupId: {
        label: 'Excise Group',
        placeholder: 'Excise Group',
      },
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
    },

    productBundles: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
      price: {
        label: 'Price',
        placeholder: 'Price',
      },
      groupName: {
        label: 'Group Name',
        placeholder: 'Group Name',
      },
      groupPrice: {
        label: 'Group Price',
        placeholder: '',
      },
      groupTax: {
        label: 'VAT %',
        placeholder: '',
      },
    },

    productPackagings: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      volume: {
        label: 'Volume (ℓ)',
        placeholder: 'Volume (ℓ)',
      },
      qtyInCrate: {
        label: 'Quantity in Crate',
        placeholder: 'Quantity in Crate',
      },
      packagingTypeId: {
        label: 'Packaging Type',
        placeholder: 'Packaging Type',
      },
      packagingMaterialId: {
        label: 'Packaging Material',
        placeholder: 'Packaging Material',
      },
      materialId: {
        label: 'Raw material used for each unit tapped',
        placeholder: 'Raw material',
      },
      crateMaterialId: {
        label: 'Raw material used for each crate tapped.',
        placeholder: 'Crate raw material',
      },
      overrideProductsConfirm: {
        title: 'Override related products',
        description:
          'This will update all excise and deposit of products that belong to this package.',
      },
    },

    productTags: {
      tag: {
        label: 'Tag',
        placeholder: 'Tag',
      },
    },

    priceFields: {
      field: {
        label: 'Field',
        placeholder: 'Field',
      },
    },
    products: {
      number: {
        label: 'Number',
        placeholder: 'Number',
      },
      exciseGroupId: {
        label: 'Excise Group',
        placeholder: 'Excise Group',
      },
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
      subType: {
        label: 'Sub Type',
        placeholder: 'Select Sub Type',
      },
      recommendations: {
        label: 'Recommended for',
        placeholder: 'Select Recommendations',
      },
      note: {
        label: 'Internal Note',
        placeholder: 'Internal Note',
      },
      isActive: {
        label: 'Active product',
        placeholder: 'Yes',
      },
      containSugar: {
        label: 'Contains Sugar',
        placeholder: 'Activate sugar content',
      },
      lowCalorie: {
        label: 'Low-calorie?',
        placeholder: 'Mark if the product is low-calorie (BROD report)',
      },
      containsAlcohol: {
        label: 'Contains Alcohol',
        placeholder: 'Yes',
      },
      externalId: {
        label: 'External ID',
        placeholder: 'External ID',
      },
      exciseAlcoholGroup: {
        label: 'Select a Product Group',
        placeholder: 'Product Groups',
      },
      excisePackagingGroup: {
        label: 'Select Packaging Excise Group',
        placeholder: 'Select Packaging Excise Group',
      },
      exciseBasicGroup: {
        label: 'Select Basic Excise Group',
        placeholder: 'Select Basic Excise Group',
      },
      chartOfAccounts: {
        label: 'Select accounting',
        placeholder: 'Accounting',
      },
      productTagId: {
        label: 'Select a Product Tags',
        placeholder: 'Product Tags',
      },
      productGroupId: {
        label: 'Select a Product Group',
        placeholder: 'Product Group',
      },
      alcoholPercentage: {
        label: 'Alkohol %',
        placeholder: 'ABV',
      },
      productPackagingId: {
        label: 'Select a Packaging',
        placeholder: 'Product Packaging',
      },
      productPackagingName: {
        label: 'Product Packaging',
        placeholder: 'Product Packaging',
      },
      packagingType: {
        label: 'Packaging Type',
        placeholder: 'Packaging Type',
      },
      productTypeId: {
        label: 'Select a Product Type',
        placeholder: 'Product Types',
      },
      productSubtype: {
        label: 'Subtype',
        placeholder: 'Product subtype',
      },
      productSubtypeId: {
        label: 'Subtype',
        placeholder: 'Product Sub Types',
      },
      productType: {
        label: 'Select a Product Type',
        placeholder: 'Product Types',
      },
      productParentId: {
        label: 'Select a Parent Product',
        placeholder: 'Parent Product',
      },
      taxId: {
        label: 'Select a VAT Percentage',
        placeholder: 'VAT',
      },
      price: {
        label: 'Price',
        placeholder: 'Price',
      },
      retailPrice: {
        label: 'Retail Price',
        placeholder: 'Retail Price',
      },
      marketplace: {
        label: 'Marketplace Price',
        placeholder: 'Marketplace Price',
      },
      duration: {
        label: 'Duration',
        placeholder: 'Duration',
      },
      breaktime: {
        label: 'Breaktime',
        placeholder: 'Breaktime',
      },
      appointable: {
        label: 'Is appointable?',
        placeholder: 'Yes',
      },
      icon: {
        label: 'Select a Icon',
        placeholder: 'Icon',
        changeImage: 'Change Image',
        removeImage: 'Remove Image',
      },
      image: {
        label: 'Select an image',
        placeholder: 'Image',
        changeImage: 'Change Image',
      },
      depositCheck: {
        label: 'Deposit',
        placeholder: 'Deposit',
      },
      deposit: {
        label: 'Deposit?',
        placeholder: '',
      },
      productDepositCheckbox: {
        label: 'Deposit',
        placeholder: 'Deposit',
      },
      productDepositId: {
        label: 'Deposit',
        placeholder: 'Deposit',
      },
      overrideProducts: {
        label: 'Override products',
        placeholder: '',
      },
      purchasePrice: {
        label: 'Purchase price',
        placeholder: '',
      },
      costPrice: {
        label: 'Cost price',
        placeholder: '',
      },
      salesPriceVinhusetAsko: {
        label: 'Sales Price Vinhuset Asko',
        placeholder: '',
      },
      coop: {
        label: 'Coop',
        placeholder: '',
      },
      rema1000: {
        label: 'Rema 1000',
        placeholder: '',
      },
      excisable: {
        label: 'Excisable',
        placeholder: 'Active excisable',
      },
      paidExcise: {
        label: 'Paid Excise',
        placeholder: '',
      },
      producer: {
        label: 'Producer name',
        placeholder: '',
      },
      region: {
        label: 'Region',
        placeholder: '',
      },
      subRegion: {
        label: 'SubRegion',
        placeholder: '',
      },
      country: {
        label: 'Country',
        placeholder: '',
      },
      vintage: {
        label: 'Vintage',
        placeholder: '',
      },
      alcohol_percentage: {
        label: 'Alcohol (%)',
        placeholder: '',
      },
      bottle_volume: {
        label: 'Bottle volum (ℓ)',
        placeholder: '',
      },
      sugar: {
        label: 'Sugar (g)',
        placeholder: '',
      },
      acid: {
        label: 'Acid',
        placeholder: '',
      },
      fullness: {
        label: 'Fullness',
        placeholder: '',
      },
      freshness: {
        label: 'Freshness',
        placeholder: '',
      },
      bitterness: {
        label: 'Bitterness',
        placeholder: '',
      },
      sweetness: {
        label: 'Sweetness',
        placeholder: '',
      },
      tannins: {
        label: 'Tannins',
        placeholder: '',
      },
      colour: {
        label: 'Colour',
        placeholder: '',
      },
      odour: {
        label: 'Odor',
        placeholder: '',
      },
      taste: {
        label: 'Taste',
        placeholder: '',
      },
      storagePotential: {
        label: 'Storage Potential',
        placeholder: '',
      },
      ingredients: {
        label: 'Ingredients',
        placeholder: '',
      },
      organic: {
        label: 'Organic',
        placeholder: '',
      },
      biodynamic: {
        label: 'Biodynamic',
        placeholder: '',
      },
      locallyProduced: {
        label: 'Locally Produced',
        placeholder: '',
      },
      environmentallySmart: {
        label: 'Environmentally Smart',
        placeholder: '',
      },
      freeOrLowOnGluten: {
        label: 'Free Or Low On Gluten',
        placeholder: '',
      },
      kosher: {
        label: 'Kosher',
        placeholder: '',
      },
      cork_type: {
        label: 'Cork type',
        placeholder: '',
      },
      packaging_type: {
        label: 'Package Type',
        placeholder: '',
      },
      gtin: {
        label: 'Main GTIN number',
        placeholder: '',
      },
      gtinMultipack: {
        label: 'GTIN multipack',
        placeholder: '',
      },
      sa: {
        label: 'SA # ',
        placeholder: 'Suppliers Article number',
      },
      nobb: {
        label: 'NOBB #',
        placeholder: 'Norwegian construction number',
      },
      sourceProductId: {
        label: 'Source Product',
        placeholder: 'Source Product',
      },
      destinationProductId: {
        label: 'Merge to',
        placeholder: 'Merge to',
      },
      qty: {
        label: 'Quantity',
        placeholder: 'Quantity',
      },
      is_taxable: {
        label: 'Is Taxable',
        placeholder: 'Taxable',
      },
      inventoryExclude: {
        label: 'Inventory Excluded',
        placeholder: 'Yes',
      },
      priceField: {
        label: 'Price Field',
        placeholder: 'Price Field',
      },
      priceFieldPrice: {
        label: 'Price',
        placeholder: 'Price',
      },
      retailPriceVmp: {
        label: 'Retail Price Vmp',
        placeholder: '',
      },
      ddpVmp: {
        label: 'ddpVmp',
        placeholder: '',
      },
      salePriceHoreca: {
        label: 'Sale Price Horeca',
        placeholder: '',
      },
      salesPriceAsko: {
        label: 'Sales Price Asko',
        placeholder: '',
      },
      salesPriceVinhuset: {
        label: 'Sales Price Vinhuset',
        placeholder: '',
      },
      salesPriceWholesale: {
        label: 'Sales Price Wholesale',
        placeholder: '',
      },
      salesPriceGrocery: {
        label: 'Sales Price Grocery',
        placeholder: '',
      },
      salesPriceBusiness: {
        label: 'Sales Price Business',
        placeholder: '',
      },
      salesPriceSpecialtyStore: {
        label: 'Sales Price Specialty Store',
        placeholder: '',
      },
      packaging: {
        label: 'Packaging',
        placeholder: '',
      },
      weightUnit: {
        label: 'Weight Unit',
        placeholder: '',
      },
      weightMultipack: {
        label: 'Weight Multi Pack',
        placeholder: '',
      },
      measureUnit: {
        label: 'Unit of Measure',
        placeholder: '',
      },
      measureMultiPackaging: {
        label: 'Measure Multi Packaging',
        placeholder: '',
      },
      numberUnitsMultiPackaging: {
        label: 'Number of Units Multi Packaging',
        placeholder: '',
      },
      numberUnitsPallet: {
        label: 'Number Units Pallet',
        placeholder: '',
      },
      availableVinhuset: {
        label: 'Available Vinhuset',
        placeholder: '',
      },
      availableAsko: {
        label: 'Available Asko',
        placeholder: '',
      },
      epd: {
        label: 'EPD',
        placeholder: '',
      },
      sku: {
        label: 'SKU',
        placeholder: '',
      },
      vmp: {
        label: 'VMP',
        placeholder: '',
      },
      internalNote: {
        label: 'Internal Note',
        placeholder: '',
      },
      depositSystemId: {
        label: 'Deposit System',
        placeholder: 'Deposit System',
      },
      bottleVolume: {
        label: 'Bottle Volume',
        placeholder: 'Bottle Volume',
      },
      corkType: {
        label: 'Cork Type',
        placeholder: 'Cork Type',
      },
      lastChanged: {
        label: 'Last Changed',
        placeholder: 'Last Changed',
      },
      marketplaceEnabled: {
        label: 'Marketplace',
        placeholder: 'Enabled',
      },
      shortDescription: {
        label: 'Short Description',
        placeholder: 'Enter product short description',
      },
      longDescription: {
        label: 'Long Description',
        placeholder: 'Enter product long description',
      },
      manualProcessOrder: {
        label: 'Manual Process Order',
        placeholder: 'Enabled',
      },
      unProductCodeId: {
        label: 'UN Product Code',
        placeholder: 'Search UN Product Code...',
      },
      updateSku: {
        label: 'Update SKU?',
        placeholder: '',
      },
      minimumOrderQuantity: {
        label: 'Minimum Order Quantity',
        placeholder: '',
      },
      orderableUnitId: {
        label: 'Orderable Unit',
        placeholder: '',
      },
      syncToWoo: {
        label: 'Sync To WP Store',
        placeholder: '',
      },
      onlineStorePrice: {
        label: 'Salesprice Online Store',
        placeholder: '',
      },
      sellInCase: {
        label: 'Sell In Case',
        placeholder: '',
      },
      minQty: {
        label: 'Minimum Quantity',
        placeholder: '',
      },
      groupOf: {
        label: 'Group Of',
        placeholder: '',
      },
      packagingMaterial: {
        label: 'Packaging Material',
        placeholder: '',
      },
      packagingMaterialId: {
        label: 'Packaging Material Id',
        placeholder: '',
      },
      packagingName: {
        label: 'Packaging Name',
        placeholder: '',
      },
      packagingQuantity: {
        label: 'Quantity in Package',
        placeholder: '',
      },
    },

    materials: {
      number: {
        label: 'Number',
        placeholder: 'Number',
      },
      materialTypeId: {
        label: 'Material Type',
        placeholder: 'Material Type',
      },
      unitMeasureId: {
        label: 'Unit of Measure',
        placeholder: 'Unit of Measure',
      },
      supplierId: {
        label: 'Supplier/Producer',
        placeholder: 'Supplier/Producer',
      },
      minimumStockLevel: {
        label: 'Minimum Stock Level',
        placeholder: 'Minimum Stock Level',
      },
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
    },

    batches: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      batchNumber: {
        label: 'Batch Number',
        placeholder: 'Batch Number',
      },
      priorityNumber: {
        label: 'Priority Number',
        placeholder: 'Priority Number',
      },
      recipeId: {
        label: 'Recipe',
        placeholder: 'Recipe',
      },
      plannedStartingDate: {
        label: 'Planned Starting Date',
        placeholder: 'Planned Starting Date',
      },
      startDate: {
        label: 'Start Date',
        placeholder: 'Start Date',
      },
      endDate: {
        label: 'End Date',
        placeholder: 'End Date',
      },
      bestBeforeDate: {
        label: 'Best Before Date',
        placeholder: 'Best Before Date',
      },
      expirationDate: {
        label: 'Expiration Date',
        placeholder: 'Expiration Date',
      },
      notes: {
        label: 'Notes',
        placeholder: 'Notes',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
      timestamp: {
        label: 'Timestamp',
        placeholder: 'Timestamp',
      },
      statuses: {
        planned: 'Plan',
        started: 'Start New',
        completed: 'Register Done',
      },
    },

    recipes: {
      recipeTypeId: {
        label: 'Recipe Type',
        placeholder: 'Recipe Type',
      },
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      step: {
        label: 'Step',
        placeholder: 'Step',
      },
      notes: {
        label: 'Notes',
        placeholder: 'Notes',
      },
      product: {
        label: 'Product',
        placeholder: 'Product',
      },
      ingredienceIds: {
        label: 'Ingrediences',
        placeholder: 'Ingrediences',
      },
      equipmentId: {
        label: 'Equipment',
        placeholder: 'Equipment',
      },
    },

    equipments: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      isActive: {
        label: 'Status',
        placeholder: 'Active',
      },
    },

    campaigns: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
      campaignTypeId: {
        label: 'Campaign Type',
        placeholder: 'Campaign Type',
      },
      newsSubscriberListId: {
        label: 'List',
        placeholder: 'List',
      },
    },

    subscriberList: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      selectDefaultEmail: {
        label: 'Use Default Email',
        placeholder: '',
      },
      fromEmail: {
        label: 'From Email',
        placeholder: 'From Email',
      },
      selectDefaultName: {
        label: 'Use Default Name',
        placeholder: '',
      },
      fromName: {
        label: 'From Name',
        placeholder: 'From Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
      doubleOptinRequired: {
        label: 'Double optin',
        placeholder: '',
      },
      optinEmailSubject: {
        label: 'Subject',
        placeholder: 'Subject',
      },
      optinEmailBody: {
        label: 'Body',
        placeholder: 'Body',
      },
    },

    news: {
      subject: {
        label: 'Subject',
        placeholder: 'Subject',
      },
      body: {
        label: 'Body',
        placeholder: 'Body',
      },
      sendAfterDate: {
        label: 'Send date',
        placeholder: 'Send date',
      },
      sendAfterTime: {
        label: 'Send time',
        placeholder: 'Send time',
      },
      sendAfter: {
        label: 'Send after (hours)',
        placeholder: 'Send after',
      },
      testEmail: {
        label: 'Test email',
        placeholder: 'mail@mail.com',
      },
      testEmailCheck: {
        label: 'Use custom email',
        placeholder: '',
      },
      status: {
        label: 'Status',
      },
      htmlEmail: {
        label: 'Use Html Email',
        placeholder: '',
      },
    },

    orders: {
      createdAt: {
        label: 'Order Date',
        placeholder: 'Order Date',
      },
      orderTypeId: {
        label: 'Order Type',
        placeholder: 'Order Type',
      },
      projectId: {
        label: 'Project',
        placeholder: 'Project',
      },
      productId: {
        label: 'Select the product',
        placeholder: 'Product',
      },
      batchId: {
        label: 'Select a batch',
        placeholder: 'Batch',
      },
      available: {
        label: 'Available',
        placeholder: 'Available',
      },
      clientId: {
        label: 'Select the client',
        placeholder: 'Clients',
      },
      referenceNumber: {
        label: 'Order Reference',
        placeholder: 'Order Reference',
      },
      internalNote: {
        label: 'Internal Note',
        placeholder: 'Internal Note',
      },
      date: {
        label: 'Date',
        placeholder: 'Date',
      },
      slot: {
        label: 'Select slot',
        placeholder: 'Time Slots',
      },
      timeSlots: {
        label: 'Start time',
      },
      time: {
        label: 'Time',
        placeholder: 'Time',
      },
      duration: {
        label: 'Duration',
        placeholder: 'Duration',
      },
      details: {
        label: 'Details',
        placeholder: 'Details',
      },
      warehouseId: {
        label: 'Warehouse',
        placeholder: 'Warehouse',
      },
    },

    ediOrders: {
      deliveryDate: {
        label: 'Delivery Date',
        placeholder: 'Delivery Date',
      },
      orderNumber: {
        label: 'Vinmonopolet order number',
        placeholder: 'Select or search order number',
      },
    },

    bills: {
      languageId: {
        label: 'Select language',
        placeholder: 'Language',
      },
      currencyId: {
        label: 'Select currency',
        placeholder: 'Currency',
      },
      orderId: {
        label: 'Select the order',
        placeholder: 'Orders',
      },
      billTypeId: {
        label: 'Select the bill type',
        placeholder: 'Types',
      },
      billStatusId: {
        label: 'Select the bill status',
        placeholder: 'Statuses',
      },
      dueDate: {
        label: 'Due Date',
        placeholder: 'Due Date',
      },
      summaryGrouping: {
        label: 'Summary grouping',
        placeholder: '',
      },
      date: {
        label: 'Date',
        placeholder: 'Date',
      },
      paymentDate: {
        label: 'Payment Date',
        placeholder: 'Payment Date',
      },
      creditNoteValue: {
        label: 'Credit note value',
        placeholder: 'Value',
      },
      paymentMessage: {
        label: 'Payment Message',
        placeholder: 'Message Text / KID',
      },
      kidNumber: {
        label: 'KID Number',
        placeholder: 'KID',
      },
      note: {
        label: 'Notes',
        placeholder: 'Notes',
      },
    },

    addEditPackage: {
      packageUnitTypeId: {
        label: 'Package Unit Type',
        placeholder: 'Package Unit Type',
      },
      sscc: {
        label: 'SSCC',
        placeholder: 'Serial Shipping Container Code',
      },
      parentId: {
        label: 'Parent ID',
        placeholder: 'Parent ID',
      },
      packingLevel: {
        label: 'Package Type',
        placeholder: 'Package Type',
      },
    },

    addEditProductToPackage: {
      productName: {
        label: 'Product',
        placeholder: 'Product',
      },
      orderProductId: {
        label: 'Product',
        placeholder: 'Product',
      },
      quantity: {
        label: 'Quantity',
        placeholder: 'Quantity',
      },
      quantityUnit: {
        label: 'Quantity Unit',
        placeholder: 'Quantity Unit',
      },
      grossWeight: {
        label: 'Gross Weight',
        placeholder: 'Gross Weight',
      },
      netWeight: {
        label: 'Net Weight',
        placeholder: 'Net Weight',
      },
      stackWeight: {
        label: 'Stack Weight',
        placeholder: 'Stack Weight',
      },
      bestBefore: {
        label: 'Best Before',
        placeholder: 'Best Before',
      },
      maxTopLoad: {
        label: 'Max Top Load',
        placeholder: 'Max Top Load',
      },
      batchLotNumber: {
        label: 'Batch / Lot Number',
        placeholder: 'Batch / Lot Number',
      },
      temperatureRequirement: {
        label: 'Temperature (in °C)',
        placeholder: 'Temperature (in °C)',
      },
    },
  },

  table: {
    noData: 'No data found.',
    projects: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      description: {
        label: 'Description',
        placeholder: 'Description',
      },
    },
    clientReports: {
      id: 'id',
      name: 'Name',
      clientNumber: 'Client #',
      balance: 'Balance',
      createdAt: 'Created At',
      lastSent: 'Last Sent',
    },
    stock: {
      products: {
        productId: {
          label: 'Name',
          placeholder: 'Name',
        },
        batchId: {
          label: 'Batch',
          placeholder: 'Select batch',
        },
        currentCount: {
          label: 'Current Count',
          placeholder: 'Current Count',
        },
        physicalCount: {
          label: 'Physical Count',
          placeholder: 'Physical Count',
        },
        variance: {
          label: 'Variance',
          placeholder: 'Variance',
        },
      },
    },
    adjustment: {
      products: {
        productId: {
          label: 'Product',
          placeholder: 'Pick a product',
        },
        batchId: {
          label: 'Batch',
          placeholder: 'Batch',
        },
        qty: {
          label: 'Adjustment (+/-)',
          placeholder: 'Adjustment (+/-)',
          customDeduct: 'Deduct',
        },
        currentAdjustment: {
          label: 'System inventory',
          placeholder: 'System inventory',
        },
        exciseAdditionalCode: {
          label: 'Additional Code',
          placeholder: '',
        },
      },
    },
    warehouseReports: {
      productName: 'Product',
      productValue: 'Product Value',
      nameOfWarehouse: 'Warehouse',
      productNumber: 'Number',
      vmpNumber: 'VMP Number',
      qtyAvailable: 'Quantity',
    },
    products: {
      productId: {
        label: 'Name',
        placeholder: 'Name',
      },
      qty: {
        label: 'Quantity',
        placeholder: 'Quantity',
      },
      priceField: {
        label: 'Price Field',
        placeholder: 'Price Field',
      },
      priceFieldPrice: {
        label: 'Price',
        placeholder: 'Price',
      },
    },
    shippingProviders: {
      name: {
        label: 'Name',
        placeholder: 'Name',
      },
      code: {
        label: 'Code',
        placeholder: 'Code',
      },
    },
    productBundles: {
      productId: {
        label: 'Product',
        placeholder: 'Product',
      },
      price: {
        label: 'Price',
        placeholder: 'Price',
      },
      qty: {
        label: 'Qty',
        placeholder: 'Qty',
      },
    },
    productsCustom: {
      productId: {
        label: 'Name',
        placeholder: 'Name',
      },
      qty: {
        label: 'Quantity',
        placeholder: 'Quantity',
      },
      currentAdjustment: {
        label: 'System Stock Count',
        placeholder: 'System Stock Count',
      },
      qtyReceive: {
        label: 'Quantity Received',
        placeholder: 'Quantity Received',
      },
      qtyDamage: {
        label: 'Quantity Damage',
        placeholder: 'Quantity Damage',
      },
      costPrice: {
        label: 'Cost Price',
        placeholder: 'Cost Price',
      },
      purchasePrice: {
        label: 'Purchase Price',
        placeholder: 'Purchase Price',
      },
      notes: {
        label: 'Notes',
        placeholder: 'Notes',
      },
      batchId: {
        label: 'Batch',
        placement: 'Batch',
      },
    },
    orderProducts: {
      addProductsButton: 'Add Products',
      addAllBillProductsButton: 'Add all invoice lines',
      addAllBillProductsNothing: 'All invoice lines are already on this credit note.',
      addAllBillProductsSuccess: 'Added {count} line(s) to the credit note.',
      addAllBillProductsError: 'Could not add all lines. Try adding them individually.',
      name: {
        label: 'Description',
        placeholder: 'Name',
      },
      note: {
        label: 'Note',
        placeholder: 'Note',
      },
      productDepositId: {
        label: 'Deposit',
        placeholder: 'Deposit',
      },
      taxId: {
        label: 'Tax (%)',
        placeholder: 'Select...',
      },
      batchId: {
        label: 'Batch',
        placeholder: 'Select...',
      },
      batchIds: {
        label: 'Batch',
        placeholder: 'Select...',
      },
      transactions: {
        label: 'Transactions',
        placeholder: 'Select...',
      },
      available: {
        label: 'Available',
        placeholder: 'Available',
      },
      price: {
        label: 'Unit Price',
        placeholder: 'Price',
      },
      quantity: {
        label: 'Quantity',
        placeholder: 'Quantity',
      },
      discount: {
        label: 'Discount (%)',
        placeholder: 'Discount (%)',
      },
      quantityOrdered: {
        label: 'Qty Ordered',
        placeholder: 'Qty Ordered',
      },
      quantityConfirmed: {
        label: 'Qty Confirmed',
        placeholder: 'Qty Confirmed',
      },
      quantityReceived: {
        label: 'Qty Received',
        placeholder: 'Qty Received',
      },
      quantityUnconfirmed: {
        label: 'Unconfirmed',
        placeholder: 'Unconfirmed',
      },
      returnCodeDescription: {
        label: 'Return Reason',
      },
      unitTypeId: {
        label: 'Unit Type',
        placeholder: '',
      },
      unitQuantity: {
        label: 'Unit Qty',
        placeholder: '',
      },
    },
    creditNoteProducts: {
      billProductId: {
        label: 'Product',
        placeholder: 'Choose a Product',
      },
      orderProductId: {
        label: 'Product',
        placeholder: 'Choose a Product',
      },
      productDepositId: {
        label: 'Deposit',
        placeholder: 'Deposit',
      },
      taxId: {
        label: 'Tax (%)',
        placeholder: 'Select...',
      },
      price: {
        label: 'Price',
        placeholder: 'Price',
      },
      quantity: {
        label: 'Quantity',
        placeholder: 'Quantity',
      },
      discount: {
        label: 'Discount (%)',
        placeholder: 'Discount (%)',
      },
    },
    businessHours: {
      addOpeningHours: 'Add Opening Hours',
      businessDays: {
        placeholder: 'Days',
        label: 'Days',
      },
      start: {
        placeholder: 'Start time',
        label: 'Start Time',
      },
      end: {
        placeholder: 'End time',
        label: 'End Time',
      },
    },
    businessHourExceptions: {
      addExceptionalHours: 'Add Exceptional Hours',
      date: {
        placeholder: 'Date',
        label: 'Date',
      },
      start: {
        placeholder: 'Start time',
        label: 'Start Time',
      },
      end: {
        placeholder: 'End time',
        label: 'End Time',
      },
      message: {
        placeholder: 'Message',
        label: 'Message',
      },
    },
    recipeIngrediences: {
      materialId: {
        label: 'Material',
        placeholder: 'Material',
      },
      amount: {
        label: 'Amount',
        placeholder: 'Amount',
      },
      unitMeasure: {
        label: 'Unit of Measure',
        placeholder: 'Unit of Measure',
      },
      deductedAmount: {
        label: 'Deducted Amount',
        placeholder: 'Deducted Amount',
      },
      noResult: 'No ingrediences added yet.',
    },
    ediOrderItems: {
      name: {
        label: 'Product',
        placeholder: 'Name',
      },
      price: {
        label: 'Price',
      },
      quantityOrdered: {
        label: 'Quantity Ordered',
      },
      quantityConfirmed: {
        label: 'Quantity Confirmed',
      },
      max: {
        label: 'Max',
      },
    },
    billProducts: {
      billProductId: {
        label: 'Product',
        placeholder: 'Product',
      },
      orderProductId: {
        label: 'Product',
        placeholder: 'Product',
      },
      orderProduct: {
        label: 'Product',
        placeholder: 'Product',
      },
      productDepositId: {
        label: 'Pant',
        placeholder: 'Velg pant',
      },
      taxId: {
        label: 'Tax (%)',
        placeholder: 'Tax...',
      },
      price: {
        label: 'Price',
        placeholder: 'Price',
      },
      quantity: {
        label: 'Quantity',
        placeholder: 'Quantity',
      },
      discount: {
        label: 'Discount (%)',
        placeholder: 'Discount (%)',
      },
      ref: {
        label: 'Ref #',
        placeholder: 'Ref #',
      },
    },
  },

  // ElementUI locale
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear',
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      year: '',
      month1: 'Jan',
      month2: 'Feb',
      month3: 'Mar',
      month4: 'Apr',
      month5: 'May',
      month6: 'Jun',
      month7: 'Jul',
      month8: 'Aug',
      month9: 'Sep',
      month10: 'Oct',
      month11: 'Nov',
      month12: 'Dec',
      // week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
      },
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select',
    },
    cascader: {
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: '',
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input',
    },
    upload: {
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue',
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
    },
    tree: {
      emptyText: 'No Data',
    },
  },

  creditNoteWarning: {
    invoiceInfo: {
      exciseInventoryActivated:
        'You have excise and inventory module activated on your account. Make sure to mark you credit note as cleared in order to trigger a product return!',
      specialChargeActivated:
        'You have a special charge activated in your account. Remember to complete the credit note to register any returns!',
      storageModuleEnabled:
        'You have storage module enabled in your account. Remember to complete the credit note to register any returns!',
      noClientEmail:
        'You can\'t send a credit note since the client\'s email is missing.',
    },
  },

  warnings: {
    billReminder: {
      unableToCreateWithFee: 'Unable to create reminder with fees.',
      reasons: {
        max2: 'because you have already created 2 reminder with fees.',
        notDue: 'a reminder with a fee cannot be created before 14 days after the due date.',
        oneReminderFee: 'because you already sent 1st reminder, before you can sent again please wait',
        oneReminderFeeDays: 'days before sending a new reminder.',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locale/en/index.js